/* Nice Select 2 Js */
!(function (e, t) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
        ? (exports.NiceSelect = t())
        : (e.NiceSelect = t());
})(self, () =>
  (() => {
    "use strict";
    var e = {
        d: (t, i) => {
          for (var s in i)
            e.o(i, s) &&
              !e.o(t, s) &&
              Object.defineProperty(t, s, { enumerable: !0, get: i[s] });
        },
        o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
        r: (e) => {
          ("undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(e, "__esModule", { value: !0 }));
        },
      },
      t = {};
    function i(e) {
      var t = document.createEvent("MouseEvents");
      (t.initEvent("click", !0, !1), e.dispatchEvent(t));
    }
    function s(e) {
      var t = document.createEvent("HTMLEvents");
      (t.initEvent("change", !0, !1), e.dispatchEvent(t));
    }
    function o(e) {
      var t = document.createEvent("FocusEvent");
      (t.initEvent("focusin", !0, !1), e.dispatchEvent(t));
    }
    function n(e) {
      var t = document.createEvent("FocusEvent");
      (t.initEvent("focusout", !0, !1), e.dispatchEvent(t));
    }
    function d(e) {
      var t = document.createEvent("UIEvent");
      (t.initEvent("modalclose", !0, !1), e.dispatchEvent(t));
    }
    function l(e, t) {
      "invalid" == t
        ? (c(this.dropdown, "invalid"), h(this.dropdown, "valid"))
        : (c(this.dropdown, "valid"), h(this.dropdown, "invalid"));
    }
    function r(e, t) {
      return null != e[t] ? e[t] : e.getAttribute(t);
    }
    function a(e, t) {
      return !!e && e.classList.contains(t);
    }
    function c(e, t) {
      if (e) return e.classList.add(t);
    }
    function h(e, t) {
      if (e) return e.classList.remove(t);
    }
    (e.r(t), e.d(t, { bind: () => f, default: () => u }));
    var p = { data: null, searchable: !1, showSelectedItems: !1 };
    function u(e, t) {
      ((this.el = e),
        (this.config = Object.assign({}, p, t || {})),
        (this.data = this.config.data),
        (this.selectedOptions = []),
        (this.placeholder =
          r(this.el, "placeholder") ||
          this.config.placeholder ||
          "Select an option"),
        (this.searchtext =
          r(this.el, "searchtext") || this.config.searchtext || "Search"),
        (this.selectedtext =
          r(this.el, "selectedtext") || this.config.selectedtext || "selected"),
        (this.dropdown = null),
        (this.multiple = r(this.el, "multiple")),
        (this.disabled = r(this.el, "disabled")),
        this.create());
    }
    function f(e, t) {
      return new u(e, t);
    }
    return (
      (u.prototype.create = function () {
        ((this.el.style.opacity = "0"),
          (this.el.style.width = "0"),
          (this.el.style.padding = "0"),
          (this.el.style.height = "0"),
          this.data ? this.processData(this.data) : this.extractData(),
          this.renderDropdown(),
          this.bindEvent());
      }),
      (u.prototype.processData = function (e) {
        var t = [];
        (e.forEach((e) => {
          t.push({
            data: e,
            attributes: {
              selected: !!e.selected,
              disabled: !!e.disabled,
              optgroup: "optgroup" == e.value,
            },
          });
        }),
          (this.options = t));
      }),
      (u.prototype.extractData = function () {
        var e = this.el.querySelectorAll("option,optgroup"),
          t = [],
          i = [],
          s = [];
        (e.forEach((e) => {
          if ("OPTGROUP" == e.tagName)
            var s = { text: e.label, value: "optgroup" };
          else
            s = {
              text: e.innerText,
              value: e.value,
              selected:
                null != e.getAttribute("selected") || this.el.value == e.value,
              disabled: null != e.getAttribute("disabled"),
            };
          var o = {
            selected: e.selected,
            disabled: e.disabled,
            optgroup: "OPTGROUP" == e.tagName,
          };
          (t.push(s), i.push({ data: s, attributes: o }));
        }),
          (this.data = t),
          (this.options = i),
          this.options.forEach((e) => {
            e.attributes.selected && s.push(e);
          }),
          (this.selectedOptions = s));
      }),
      (u.prototype.renderDropdown = function () {
        var e = [
          "nice-select",
          r(this.el, "class") || "",
          this.disabled ? "disabled" : "",
          this.multiple ? "has-multiple" : "",
        ];
        let t = '<div class="nice-select-search-box">';
        ((t += `<input type="text" class="nice-select-search" placeholder="${this.searchtext}..." title="search"/>`),
          (t += "</div>"));
        var i = `<div class="${e.join(" ")}" tabindex="${
          this.disabled ? null : 0
        }">`;
        ((i += `<span class="${
          this.multiple ? "multiple-options" : "current"
        }"></span>`),
          (i += '<div class="nice-select-dropdown">'),
          (i += `${this.config.searchable ? t : ""}`),
          (i += '<ul class="list"></ul>'),
          (i += "</div>"),
          (i += "</div>"),
          this.el.insertAdjacentHTML("afterend", i),
          (this.dropdown = this.el.nextElementSibling),
          this._renderSelectedItems(),
          this._renderItems());
      }),
      (u.prototype._renderSelectedItems = function () {
        if (this.multiple) {
          var e = "";
          (this.config.showSelectedItems ||
          this.config.showSelectedItems ||
          "auto" == window.getComputedStyle(this.dropdown).width ||
          this.selectedOptions.length < 2
            ? (this.selectedOptions.forEach(function (t) {
                e += `<span class="current">${t.data.text}</span>`;
              }),
              (e = "" == e ? this.placeholder : e))
            : (e = this.selectedOptions.length + " " + this.selectedtext),
            (this.dropdown.querySelector(".multiple-options").innerHTML = e));
        } else {
          var t =
            this.selectedOptions.length > 0
              ? this.selectedOptions[0].data.text
              : this.placeholder;
          this.dropdown.querySelector(".current").innerHTML = t;
        }
      }),
      (u.prototype._renderItems = function () {
        var e = this.dropdown.querySelector("ul");
        this.options.forEach((t) => {
          e.appendChild(this._renderItem(t));
        });
      }),
      (u.prototype._renderItem = function (e) {
        var t = document.createElement("li");
        if (((t.innerHTML = e.data.text), e.attributes.optgroup))
          c(t, "optgroup");
        else {
          t.setAttribute("data-value", e.data.value);
          var i = [
            "option",
            e.attributes.selected ? "selected" : null,
            e.attributes.disabled ? "disabled" : null,
          ];
          (t.addEventListener("click", this._onItemClicked.bind(this, e)),
            t.classList.add(...i));
        }
        return ((e.element = t), t);
      }),
      (u.prototype.update = function () {
        if ((this.extractData(), this.dropdown)) {
          var e = a(this.dropdown, "open");
          (this.dropdown.parentNode.removeChild(this.dropdown),
            this.create(),
            e && i(this.dropdown));
        }
        r(this.el, "disabled") ? this.disable() : this.enable();
      }),
      (u.prototype.disable = function () {
        this.disabled || ((this.disabled = !0), c(this.dropdown, "disabled"));
      }),
      (u.prototype.enable = function () {
        this.disabled && ((this.disabled = !1), h(this.dropdown, "disabled"));
      }),
      (u.prototype.clear = function () {
        (this.resetSelectValue(),
          (this.selectedOptions = []),
          this._renderSelectedItems(),
          this.update(),
          s(this.el));
      }),
      (u.prototype.destroy = function () {
        this.dropdown &&
          (this.dropdown.parentNode.removeChild(this.dropdown),
          (this.el.style.display = ""));
      }),
      (u.prototype.bindEvent = function () {
        (this.dropdown.addEventListener("click", this._onClicked.bind(this)),
          this.dropdown.addEventListener(
            "keydown",
            this._onKeyPressed.bind(this),
          ),
          this.dropdown.addEventListener("focusin", o.bind(this, this.el)),
          this.dropdown.addEventListener("focusout", n.bind(this, this.el)),
          this.el.addEventListener("invalid", l.bind(this, this.el, "invalid")),
          window.addEventListener("click", this._onClickedOutside.bind(this)),
          this.config.searchable && this._bindSearchEvent());
      }),
      (u.prototype._bindSearchEvent = function () {
        var e = this.dropdown.querySelector(".nice-select-search");
        (e &&
          e.addEventListener("click", function (e) {
            return (e.stopPropagation(), !1);
          }),
          e.addEventListener("input", this._onSearchChanged.bind(this)));
      }),
      (u.prototype._onClicked = function (e) {
        var t, i;
        if (
          (e.preventDefault(),
          a(this.dropdown, "open")
            ? this.multiple || (h(this.dropdown, "open"), d(this.el))
            : (c(this.dropdown, "open"),
              (t = this.el),
              (i = document.createEvent("UIEvent")).initEvent(
                "modalopen",
                !0,
                !1,
              ),
              t.dispatchEvent(i)),
          a(this.dropdown, "open"))
        ) {
          var s = this.dropdown.querySelector(".nice-select-search");
          s && ((s.value = ""), s.focus());
          var o = this.dropdown.querySelector(".focus");
          (h(o, "focus"),
            c((o = this.dropdown.querySelector(".selected")), "focus"),
            this.dropdown.querySelectorAll("ul li").forEach(function (e) {
              e.style.display = "";
            }));
        } else this.dropdown.focus();
      }),
      (u.prototype._onItemClicked = function (e, t) {
        var i = t.target;
        a(i, "disabled") ||
          (this.multiple
            ? a(i, "selected")
              ? (h(i, "selected"),
                this.selectedOptions.splice(this.selectedOptions.indexOf(e), 1),
                this.el
                  .querySelector(`option[value="${i.dataset.value}"]`)
                  .removeAttribute("selected"))
              : (c(i, "selected"), this.selectedOptions.push(e))
            : (this.selectedOptions.forEach(function (e) {
                h(e.element, "selected");
              }),
              c(i, "selected"),
              (this.selectedOptions = [e])),
          this._renderSelectedItems(),
          this.updateSelectValue());
      }),
      (u.prototype.updateSelectValue = function () {
        if (this.multiple) {
          var e = this.el;
          this.selectedOptions.forEach(function (t) {
            var i = e.querySelector(`option[value="${t.data.value}"]`);
            i && i.setAttribute("selected", !0);
          });
        } else
          this.selectedOptions.length > 0 &&
            (this.el.value = this.selectedOptions[0].data.value);
        s(this.el);
      }),
      (u.prototype.resetSelectValue = function () {
        if (this.multiple) {
          var e = this.el;
          this.selectedOptions.forEach(function (t) {
            var i = e.querySelector(`option[value="${t.data.value}"]`);
            i && i.removeAttribute("selected");
          });
        } else this.selectedOptions.length > 0 && (this.el.selectedIndex = -1);
        s(this.el);
      }),
      (u.prototype._onClickedOutside = function (e) {
        this.dropdown.contains(e.target) ||
          (h(this.dropdown, "open"), d(this.el));
      }),
      (u.prototype._onKeyPressed = function (e) {
        var t = this.dropdown.querySelector(".focus"),
          s = a(this.dropdown, "open");
        if (13 == e.keyCode) i(s ? t : this.dropdown);
        else if (40 == e.keyCode) {
          if (s) {
            var o = this._findNext(t);
            o &&
              (h(this.dropdown.querySelector(".focus"), "focus"),
              c(o, "focus"),
              o.scrollIntoView({ block: "nearest" }));
          } else i(this.dropdown);
          e.preventDefault();
        } else if (38 == e.keyCode) {
          if (s) {
            var n = this._findPrev(t);
            n &&
              (h(this.dropdown.querySelector(".focus"), "focus"),
              c(n, "focus"),
              n.scrollIntoView({ block: "nearest" }));
          } else i(this.dropdown);
          e.preventDefault();
        } else if (27 == e.keyCode && s) i(this.dropdown);
        else if (32 === e.keyCode && s) return !1;
        return !1;
      }),
      (u.prototype._findNext = function (e) {
        for (
          e = e
            ? e.nextElementSibling
            : this.dropdown.querySelector(".list .option");
          e;
        ) {
          if (!a(e, "disabled") && "none" != e.style.display) return e;
          e = e.nextElementSibling;
        }
        return null;
      }),
      (u.prototype._findPrev = function (e) {
        for (
          e = e
            ? e.previousElementSibling
            : this.dropdown.querySelector(".list .option:last-child");
          e;
        ) {
          if (!a(e, "disabled") && "none" != e.style.display) return e;
          e = e.previousElementSibling;
        }
        return null;
      }),
      (u.prototype._onSearchChanged = function (e) {
        var t = a(this.dropdown, "open"),
          i = e.target.value;
        if ("" == (i = i.toLowerCase()))
          this.options.forEach(function (e) {
            e.element.style.display = "";
          });
        else if (t) {
          var s = new RegExp(i);
          this.options.forEach(function (e) {
            var t = e.data.text.toLowerCase(),
              i = s.test(t);
            e.element.style.display = i ? "" : "none";
          });
        }
        (this.dropdown.querySelectorAll(".focus").forEach(function (e) {
          h(e, "focus");
        }),
          c(this._findNext(null), "focus"));
      }),
      t
    );
  })(),
);

/*=========================
    Enavi Sofa Builder JS
==========================*/

theme.EnaviSofaBuilder = (function () {
  const selectors = {
    addToCartBtn: "#AddToCart",
    cylindoViewer: "cylindo-viewer",
    bedToggle: "[data-bed-toggle-input]",
    productSelector: ".product-selector-box",
    productSelectorHeading: ".product-selector-box > .box-heading",
    dropdownAddon: ".enavi-selector_addon",
    dropdownContainer: ".option-dropdown:not(.nice2-dropdown)",
    nice2Dropdown: ".nice-2-dropdown",
    selectionLabel: ".selection-label",
    optionRadio: ".radio-option",
    fabricProduct: ".fabric-samples-card",
    firmnessProduct: ".firmness-btn",
    firmnessDescriptionRow: ".firmness-description-row",
    firmnessDescriptionLabel: ".firmness-description-label",
    firmnessDescription: ".firmness-description-text",
    filterHeading: ".filter-heading",
    fabricContainer: '[data-selector-type="Fabric"] > .box-content',
    fabricFilterOption: ".fabric-filter-option",
    fabricFilterHeading: ".fabric-filter-option > .box-heading",
    filterByPatternDropdown: "#filter-pattern-select",
    applyFilterBtn: ".apply-filter-btn",
    clearFilterBtn: ".clear-filter-btn",
    fabricMaterialModal:
      "#fabric-material-popup .product-popup-modal__content-info",
    filterBtn: ".filter-btn",
    cushionTypes: ".cushion_option",
    legProducts: ".leg_option",
    selectImage: ".selection-img",
    drawerCloseBtn: ".drawer-close-btn",
    sliderImage: ".product-images__slide .product-single__media img",
    productSlider: "product-slider",
  };

  /**
   * Shown over the viewer when Cylindo cannot draw the current selection.
   * Fabrics and legs are put on sale before they are modelled, so a selection
   * with no imagery is routine rather than an error the customer caused.
   */
  const cylindoMessages = {
    // Cylindo has no model for this product at all - nothing on the page can
    // be previewed, so this outranks the fabric notice.
    model: "Preview not available for this product yet",
    style: "Preview not available for this style yet",
    fabric: "Preview not available for this fabric yet",
    legs: "Preview not available for this leg yet",
  };

  function EnaviSofaBuilder(container) {
    if (container) {
      this.init(container);
    }
  }

  EnaviSofaBuilder.prototype = Object.assign({}, EnaviSofaBuilder.prototype, {
    init: function (container) {
      this.container = container;
      this.sectionID = this.container.dataset.sectionId;
      this.addToCart = this.select(selectors.addToCartBtn);
      this.atcPrice = this.addToCart.querySelector(".atc-price");
      this.productPriceEls = document.querySelectorAll(
        ".product-price-container .amount",
      );
      this.form = this.addToCart.closest("form");
      this.cylindoViewer = document.querySelector(selectors.cylindoViewer);
      this.bedToggle = document.querySelector(selectors.bedToggle);
      this.productSelectors = this.selectAll(selectors.productSelector);
      this.productSelectorsHeading = this.selectAll(
        selectors.productSelectorHeading,
      );
      this.optionRadios = this.selectAll(selectors.optionRadio);
      this.dropdownAddons = this.selectAll(selectors.dropdownAddon);
      this.dropdownContainers = this.selectAll(selectors.dropdownContainer);
      this.nice2Dropdowns = this.selectAll(selectors.nice2Dropdown);
      this.selectImages = this.selectAll(selectors.selectImage);
      this.fabricContainer = this.select(selectors.fabricContainer);
      this.fabricProducts = this.selectAll(selectors.fabricProduct);
      this.firmnessProducts = this.selectAll(selectors.firmnessProduct);
      this.firmnessDescriptionRow = this.select(
        selectors.firmnessDescriptionRow,
      );
      this.firmnessDescription = this.select(selectors.firmnessDescription);
      this.firmnessDescriptionLabel = this.select(
        selectors.firmnessDescriptionLabel,
      );
      this.cushionTypes = this.selectAll(selectors.cushionTypes);
      this.legProducts = this.selectAll(selectors.legProducts);
      this.drawerCloseBtn = this.selectAll(selectors.drawerCloseBtn);

      document.addEventListener(
        "pdp-fabric-samples:updated",
        this.resetEventListeners.bind(this),
      );
      document.addEventListener(
        "sofa-slider:content-changed",
        this.handleSliderContentChange.bind(this),
      );

      this.addToCart.setAttribute("data-disable-atc", "true");
      this.addToCart.type = "button";
      this.basePrice = parseInt(container.dataset.basePrice);
      this.allItems = [];
      this.requiredAddons = Array.from(this.productSelectors)
        .concat(Array.from(this.dropdownAddons))
        .filter(function (addon) {
          return addon.classList.contains("required-addon");
        });

      if (this.form) {
        this.addToCart.addEventListener("click", this.handleAtc.bind(this));
      }
      this.addEventListeners();
      this.setupDecideLater();
      this.startFabricLoading();

      this.handleDropdownChange(this.dropdownAddons);

      // Auto-select the leg option when there is only one to choose from,
      // without expanding its accordion panel
      if (this.legProducts.length === 1) {
        this.handleProductSelection(this.legProducts[0], this.legProducts, true);
      }

      if (this.cylindoViewer) {
        this.cylindoViewer.addEventListener("loaded", () => {
          this.handleCylindoDefaultFeatures();
        });
      }

      // Must run before the first `loaded` fires so the legs are already scoped
      // to the default style when Cylindo back-selects its default leg.
      this.initOttomanStyle();

      this.refreshCylindoAvailability();

      this.updateDimensions();
      this.updateSelectionText();
      this.updateStepCompletionStatus();
      this.dropdownAddons.forEach((dropdown) => {
        dropdown.addEventListener("change", () => {
          this.updateDimensions();
        });
      });

      // Bumper Opening and Chaise Width change without any dropdown changing,
      // so the dropdown listeners above never fire for them.
      document.addEventListener("sofa:configuration:changed", () => {
        this.updateDimensions();
      });

      // Read reviews scroll handlers (multiple triggers)
      // Query from document rather than this.container because the mobile
      // star-rating lives in the gallery column (desktop-hide), outside
      // the .product-information container that this.container references.
      var reviewTriggers = document.querySelectorAll(
        ".read-reviews-container, .star-rating-container",
      );
      if (reviewTriggers && reviewTriggers.length) {
        reviewTriggers.forEach(function (trigger) {
          trigger.addEventListener("click", function (e) {
            e.preventDefault();
            var target =
              document.querySelector("[data-oke-widget]") ||
              document.querySelector(
                ".okeReviews, .oke-widget, .okeReviews-widget",
              );
            if (target) {
              var y =
                target.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({ top: y, behavior: "smooth" });
            }
          });
        });
      }

      // Mobile Sticky ATC (Sofa Builder template only)
      const stickyBar = document.getElementById("MobileStickyATC");
      const stickyBarButton = document.getElementById("MobileStickyATCButton");
      if (stickyBar && stickyBarButton && this.addToCart) {
        const atcButton = this.addToCart;
        // Mirror original button classes and content
        stickyBarButton.className =
          atcButton.className + " mobile-sticky-atc__btn";
        stickyBarButton.innerHTML = atcButton.innerHTML;
        // Keep sticky button in sync with original (price updates, state changes)
        try {
          const atcMirrorObserver = new MutationObserver(function () {
            stickyBarButton.className =
              atcButton.className + " mobile-sticky-atc__btn";
            stickyBarButton.innerHTML = atcButton.innerHTML;
          });
          atcMirrorObserver.observe(atcButton, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ["class", "disabled"],
          });
        } catch (e) {}

        stickyBarButton.addEventListener("click", (e) => {
          e.preventDefault();
          const extraMargin = stickyOffset + 200; // additional space above button
          const targetY =
            atcButton.getBoundingClientRect().top +
            window.pageYOffset -
            extraMargin;
          window.scrollTo({ top: targetY, behavior: "smooth" });
          setTimeout(() => {
            atcButton.click();
          }, 400);
        });

        const mediaQuery = window.matchMedia("(max-width: 768px)");
        const stickyOffset = 110; // account for header height overlap
        const getAtcAbsoluteTop = () =>
          atcButton.getBoundingClientRect().top + window.pageYOffset;
        const bindObserver = () => {
          if (typeof IntersectionObserver !== "function") {
            const toggleSticky = () => {
              const rect = atcButton.getBoundingClientRect();
              // Treat visible when ATC intersects the viewport adjusted by header offset
              const viewportTop = stickyOffset;
              const viewportBottom = window.innerHeight;
              const isVisible =
                rect.bottom > viewportTop && rect.top < viewportBottom;
              const isBelow =
                window.pageYOffset + stickyOffset >= getAtcAbsoluteTop();
              const show = isBelow && !isVisible;
              stickyBar.classList.toggle("mobile-sticky-atc--visible", show);
              stickyBar.setAttribute("aria-hidden", show ? "false" : "true");
            };
            window.addEventListener("scroll", toggleSticky, { passive: true });
            // Set initial state based on current scroll position
            toggleSticky();
            return;
          }
          // Observer approach with header offset via rootMargin
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible = entry.isIntersecting; // with rootMargin applied
                const isBelow =
                  window.pageYOffset + stickyOffset >= getAtcAbsoluteTop();
                const show = isBelow && !visible;
                stickyBar.classList.toggle("mobile-sticky-atc--visible", show);
                stickyBar.setAttribute("aria-hidden", show ? "false" : "true");
              });
            },
            {
              root: null,
              threshold: 0,
              rootMargin: `-${stickyOffset}px 0px 0px 0px`,
            },
          );
          // Set initial state immediately on init using observer-calibrated visibility
          const initialRect = atcButton.getBoundingClientRect();
          const initialVisible =
            initialRect.bottom > stickyOffset &&
            initialRect.top < window.innerHeight;
          const initialBelow =
            window.pageYOffset + stickyOffset >= getAtcAbsoluteTop();
          const initialShow = initialBelow && !initialVisible;
          stickyBar.classList.toggle("mobile-sticky-atc--visible", initialShow);
          stickyBar.setAttribute("aria-hidden", initialShow ? "false" : "true");
          observer.observe(atcButton);
        };

        if (mediaQuery.matches) bindObserver();
        mediaQuery.addEventListener("change", (e) => {
          stickyBar.classList.remove("mobile-sticky-atc--visible");
          if (e.matches) bindObserver();
        });
      }
    },

    select: function (selector) {
      return this.container.querySelector(selector);
    },

    selectAll: function (selector) {
      return Array.prototype.slice.apply(
        this.container.querySelectorAll(selector),
      );
    },

    addEventListeners: function () {
      this.productSelectors.forEach((selector) => {
        this.initAccordion(selector, this.productSelectorsHeading);
      });

      this.initCustomSelectDropdowns();

      this.initNice2Dropdowns();

      document.addEventListener("click", this.closeAllSelect());

      this.bindCylindoErrorHandler(this.cylindoViewer);

      if (this.bedToggle) {
        this.bedToggle.addEventListener("change", this.toggleBedOpen.bind(this));
      }

      this.optionRadios.forEach((option) => {
        let initiallySelectedRadio = option.querySelector(
          'input[type="radio"]:checked',
        );
        option.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener("change", (event) => {
            if (radio.dataset.sizeImage) {
              const selectionContainer = radio.closest(".product-selector-box");
              const selectionImg =
                selectionContainer.querySelector(".selection-img");
              const headingImg =
                selectionContainer.querySelector(".heading-img");
              if (selectionImg) {
                selectionImg.src = radio.dataset.sizeImage;
                selectionImg.dataset.src = radio.dataset.sizeImage;
                selectionImg.dataset.srcset = radio.dataset.sizeImage;
                selectionImg.classList.add("lazyload");
              }
              if (headingImg) {
                headingImg.src = radio.dataset.sizeImage;
              }
            }
            this.handleDropdownChange(this.dropdownAddons);
            const productSlider = document.querySelector(
              selectors.productSlider,
            );
            if (productSlider) {
              const altText = radio.value;
              const slideIndex = findImageIndexByAlt(
                productSlider,
                selectors.sliderImage,
                altText,
              );

              if (slideIndex !== -1) {
                selectCellWhenReady(productSlider, slideIndex);
              }
            }
          });
        });
        if (initiallySelectedRadio) {
          initiallySelectedRadio.dispatchEvent(new Event("change"));
        }
      });

      function findImageIndexByAlt(container, imageSelector, altText) {
        const images = Array.from(container.querySelectorAll(imageSelector));
        return images.findIndex((img) => img.alt.includes(altText));
      }

      function selectCellWhenReady(slider, index) {
        if (typeof slider.selectCell === "function") {
          slider.selectCell(index);
        } else {
          const observer = new MutationObserver((mutations, obs) => {
            if (typeof slider.selectCell === "function") {
              slider.selectCell(index);
              obs.disconnect();
            }
          });

          observer.observe(slider, {
            attributes: true,
            childList: true,
            subtree: true,
          });
        }
      }

      this.dropdownAddons.forEach((dropdown) => {
        dropdown.addEventListener("change", (event) => {
          this.handleDropdownChange(this.dropdownAddons, event);
        });
      });

      this.drawerCloseBtn.forEach((closeEl) => {
        closeEl.addEventListener("click", () => {
          const drawerModal = closeEl.closest(".fabric-filter-modal");
          if (drawerModal.classList.contains("active")) {
            drawerModal.click();
          }
        });
      });
      this.bindFabricEvents();

      this.firmnessProducts.forEach((product) => {
        const handleFirmnessSelect = () => {
          if (this.firmnessDescription) {
            this.firmnessDescription.innerText =
              product.getAttribute("data-firmness-description") || "";
          }
          if (this.firmnessDescriptionLabel) {
            this.firmnessDescriptionLabel.innerText =
              product.getAttribute("data-product-label") || "";
          }
          if (product.getAttribute("data-firmness-description")) {
            this.firmnessDescriptionRow.classList.remove("hide");
          } else {
            this.firmnessDescriptionRow.classList.add("hide");
          }
          this.handleProductSelection(product, this.firmnessProducts);
        };
        product.addEventListener("click", handleFirmnessSelect);
        product.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleFirmnessSelect();
          }
        });
      });

      this.cushionTypes.forEach((product) => {
        product.addEventListener("click", () => {
          this.handleProductSelection(product, this.cushionTypes);
        });
        product.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleProductSelection(product, this.cushionTypes);
          }
        });
      });

      this.legProducts.forEach((product) => {
        product.addEventListener("click", () => {
          this.handleProductSelection(product, this.legProducts);
        });
        product.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleProductSelection(product, this.legProducts);
          }
        });
      });

      this.selectImages.forEach((img) => {
        img.onload = () => {
          const parentContainer = img.closest(".product-selector-box");
          if (parentContainer && parentContainer.classList.contains("active")) {
            img.parentElement.style.maxHeight = `${img.parentElement.scrollHeight}px`;
          }
        };
      });

      window.addEventListener("resize", () => {
        this.productSelectors.forEach((accordion) => {
          const boxContent = accordion.querySelector(".box-content");
          const selectorType = accordion.getAttribute("data-selector-type");

          if (accordion.classList.contains("active")) {
            if (selectorType === "Depth" || selectorType === "Size") {
              boxContent.style.overflow = "visible";
            } else {
              boxContent.style.maxHeight = boxContent.scrollHeight + "px";
            }
          }
        });
      });

      this.selectAll(".nice-select.option-select").forEach((niceDropdown) => {
        niceDropdown.addEventListener("click", () => {
          niceDropdown.closest(".box-content").style.overflow = "visible";
          const fabricFilterOptions = niceDropdown.closest(
            "#fabric-filter-options",
          );
          if (fabricFilterOptions) {
            fabricFilterOptions.style.overflow = "visible";
          }
        });
      });
    },

    bindFabricEvents: function () {
      if (!this.fabricContainer || this.fabricEventsBound) return;
      this.fabricEventsBound = true;
      const selectFabric = (event) => {
        const product = event.target.closest(selectors.fabricProduct);
        if (!product || event.target.closest("modal-opener, .product-popup-modal__button")) return;
        if (event.type === "keydown") {
          if (event.key !== "Enter" && event.key !== " ") return;
          if (event.target !== product) return;
          event.preventDefault();
        }
        this.handleProductSelection(product, this.fabricProducts);
      };
      this.fabricContainer.addEventListener("click", selectFabric);
      this.fabricContainer.addEventListener("keydown", selectFabric);
    },

    resetEventListeners: function () {
      this.fabricProducts = this.selectAll(selectors.fabricProduct);
    },

    applyDefaultFabric: function () {
      if (!this.defaultFabric || this.defaultFabricApplied) return;
      if (window.SofaConfigUrl?.has("fabric")) return;
      if (this.fabricProducts.some((card) => card.classList.contains("active")) ||
          this.container.querySelector(".fabric-samples-decide-later.active")) return;
      const name = this.defaultFabric.replace(/-/g, " ").toLowerCase();
      const option = this.fabricProducts.find((card) => card.dataset.productLabel?.toLowerCase().includes(name));
      if (option) {
        this.defaultFabricApplied = true;
        this.handleProductSelection(option, this.fabricProducts);
      }
    },

    handleSliderContentChange: function () {
      // Recalculate height for the size selector accordion when slider content changes
      const sizeSelector = document.querySelector(
        '[data-selector-type="Size"]',
      );
      if (sizeSelector && sizeSelector.classList.contains("active")) {
        const boxContent = sizeSelector.querySelector(".box-content");
        if (boxContent) {
          // Force recalculation by resetting maxHeight
          boxContent.style.maxHeight = "none";
          // Use setTimeout to allow DOM to update, then set proper height
          setTimeout(() => {
            boxContent.style.maxHeight = boxContent.scrollHeight + "px";
          }, 0);
        }
      }
    },

    initAccordion: function (accordion, allHeadings) {
      const selectorHeading = accordion.querySelector(".box-heading");
      if (selectorHeading) {
        const toggleAccordion = (e) => {
          e.stopPropagation();
          if (
            !e.target.classList.contains("panel-popup") &&
            e.target.closest(".panel-popup")
          ) {
            return;
          }
          const isActive =
            selectorHeading.parentElement.classList.contains("active");

          selectorHeading.parentElement.classList.toggle("active", !isActive);
          selectorHeading.setAttribute("aria-expanded", String(!isActive));

          const boxContent =
            selectorHeading.parentElement.querySelector(".box-content");
          const selectorType =
            selectorHeading.parentElement.getAttribute("data-selector-type");
          // Start the fabric load before measuring, so the box opens at the
          // height reserved for the catalog instead of growing when it arrives.
          if (!isActive && selectorType === "Fabric") this.loadFabrics();
          if (boxContent) {
            boxContent.style.maxHeight = isActive
              ? "0"
              : boxContent.scrollHeight + "px";
            boxContent.style.overflow = "hidden";
            boxContent.inert = isActive;

            // For size selector with slider, recalculate after a brief delay to ensure React content is rendered
            if (!isActive && selectorType === "Size") {
              this.handleSliderContentChange();
            }

            // For Fabric selector: allow filter dropdowns to overflow after expand animation
            if (selectorType === "Fabric") {
              if (!isActive) {
                // Expanding — set overflow visible after transition ends
                const onExpandEnd = function (e) {
                  if (e.propertyName === "max-height") {
                    boxContent.style.overflow = "visible";
                    boxContent.removeEventListener(
                      "transitionend",
                      onExpandEnd,
                    );
                  }
                };
                boxContent.addEventListener("transitionend", onExpandEnd);

                // Notify scrollbar to show
                document.dispatchEvent(new CustomEvent("fabric-accordion:opened"));
              }
              // Collapsing — overflow is already set to hidden above
            }
          }

          const parentContainer = accordion.closest(".box-content");
          if (parentContainer && boxContent) {
            parentContainer.style.maxHeight =
              parentContainer.scrollHeight + boxContent.scrollHeight + "px";
          }
          this.closeAllSelect();

          selectorHeading.parentElement
            .querySelectorAll(".nice-select")
            .forEach(function (selector) {
              selector.classList.remove("open");
            });
        };

        selectorHeading.addEventListener("click", toggleAccordion);
        selectorHeading.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            if (e.target.closest(".panel-popup")) return;
            e.preventDefault();
            toggleAccordion(e);
          }
        });
      }
    },

    /* Custom Select Dropdown W3 */
    initCustomSelectDropdowns: function () {
      var x, i, j, l, ll, selElmnt, a, b, c;
      x = this.dropdownContainers;
      l = this.dropdownContainers.length;
      var self = this;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.setAttribute("tabindex", "0");
        a.setAttribute("role", "combobox");
        a.setAttribute("aria-expanded", "false");
        a.setAttribute("aria-haspopup", "listbox");
        const selectedOption = selElmnt.options[selElmnt.selectedIndex];
        const format =
          window.theme.settings.money_with_currency_format || "${{amount}}";
        const addonPrice = `+${formatMoney(selectedOption.dataset.productPrice, format)}`;
        const baseText = selectedOption.innerHTML;
        /* a.innerHTML = this.formatOptionText(
          selElmnt.options[selElmnt.selectedIndex].innerHTML
        ); */
        a.innerHTML = self.formatOptionText(
          `${baseText} <span class="addon-price">(${addonPrice})</span>`,
        );
        a.dataset.originalText = baseText;
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV");
        var placeHolder = document.createElement("DIV");
        placeHolder.setAttribute("class", "select-placeholder");
        placeHolder.innerHTML = "Select " + x[i].dataset.addonType;
        b.appendChild(placeHolder);
        b.setAttribute("class", "select-items select-hide");
        b.setAttribute("role", "listbox");
        for (j = 1; j < ll; j++) {
          /* For each option in the original select element,
          create a new DIV that will act as an option item: */
          c = document.createElement("DIV");
          c.setAttribute("role", "option");
          let format =
            window.theme.settings.money_with_currency_format || "${{amount}}";
          const addonPrice = `+${formatMoney(selElmnt.options[j].dataset.productPrice, format)}`;
          const baseText = selElmnt.options[j].innerHTML;
          c.innerHTML = `${baseText} <span class="addon-price">(${addonPrice})</span>`;
          c.dataset.originalText = baseText;
          c.addEventListener("click", function (e) {
            /* When an item is clicked, update the original select box,
            and the selected item: */
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.dataset.originalText) {
                s.selectedIndex = i;
                h.innerHTML = self.formatOptionText(this.innerHTML);
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                s.dispatchEvent(new Event("change"));
                break;
              }
            }
            h.click();
          });
          b.appendChild(c);
          if (selElmnt.options[j].selected) {
            c.setAttribute("class", "same-as-selected");
          }
        }
        x[i].appendChild(b);
        var initiallySelectedOption = selElmnt.options[selElmnt.selectedIndex];
        var initiallySelectedDiv = b.querySelector(
          "div:nth-child(" + (selElmnt.selectedIndex + 1) + ")",
        );
        initiallySelectedDiv.setAttribute("class", "same-as-selected");
        a.addEventListener("click", function (e) {
          /* When the select box is clicked, close any other select boxes,
          and open/close the current select box: */
          e.stopPropagation();
          self.closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
          var isOpen = !this.nextSibling.classList.contains("select-hide");
          this.setAttribute("aria-expanded", String(isOpen));

          const selectorBox = this.closest(".product-selector-box");
          if (selectorBox) {
            selectorBox.classList.add("active");
            const boxContent = selectorBox.querySelector(".box-content");
            if (boxContent) {
              boxContent.style.maxHeight = boxContent.scrollHeight + "px";
              boxContent.style.overflow = "visible";
            }
          }
        });
        a.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.click();
          } else if (e.key === "Escape") {
            var listbox = this.nextSibling;
            if (!listbox.classList.contains("select-hide")) {
              listbox.classList.add("select-hide");
              this.classList.remove("select-arrow-active");
              this.setAttribute("aria-expanded", "false");
            }
          } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            var listbox = this.nextSibling;
            if (listbox.classList.contains("select-hide")) {
              this.click();
            }
            var options = listbox.querySelectorAll("[role='option']");
            if (options.length) {
              var currentIdx = Array.from(options).findIndex(function (o) { return o.classList.contains("same-as-selected"); });
              var nextIdx = e.key === "ArrowDown" ? Math.min(currentIdx + 1, options.length - 1) : Math.max(currentIdx - 1, 0);
              options[nextIdx].click();
            }
          }
        });
      }
    },

    initNice2Dropdowns: function () {
      var options = { searchable: true };
      this.nice2Dropdowns.forEach((element) => {
        NiceSelect.bind(element, options);
        element.setAttribute("tabindex", "-1");
        var scrollbar = element.parentElement && element.parentElement.querySelector("custom-scrollbar");
        if (scrollbar) scrollbar.setAttribute("tabindex", "-1");
      });
      setTimeout(() => {
        document.querySelectorAll(".nice-select-dropdown li").forEach((el) => {
          let elementText = el.innerText;
          if (elementText.includes("(Popular)")) {
            el.innerHTML = elementText.replace(
              "(Popular)",
              '<span class="popular">(Popular)</span>',
            );
          }
        }, 1000);
      });
    },

    initFabricFilterModal: function () {
      var fabricFilterModal = document.getElementById("fabricFilterModal");
      var fabricFilterMobileBtn = document.getElementById(
        "fabric-accordion-btn",
      );

      const modalContent = document.getElementById(
        "fabric-filter-modal-content",
      );

      fabricFilterMobileBtn.onclick = function () {
        if (window.innerWidth < 640) {
          let originalContent = document.getElementById(
            "fabric-filter-options",
          );
          originalContent.style.maxHeight = "unset";
          modalContent.appendChild(originalContent);
          modalContent
            .querySelectorAll(".fabric-filter-option")
            .forEach(function (element) {
              element.classList.remove("active");
              let boxContent = element.querySelector(".box-content");
              if (boxContent) {
                boxContent.style.maxHeight = "0";
              }
            });
          fabricFilterModal.classList.add("active");
        }
      };

      window.addEventListener("click", function (event) {
        if (event.target == fabricFilterModal) {
          originalContent = document.getElementById("fabric-filter-options");
          originalContent
            .querySelectorAll(".fabric-filter-option")
            .forEach(function (element) {
              element.classList.remove("active");
              let boxContent = element.querySelector(".box-content");
              if (boxContent) {
                boxContent.style.maxHeight = "0";
                boxContent.style.overflow = "hidden";
              }
            });
          document
            .querySelector(".fabric-filter_container")
            .appendChild(originalContent);
          fabricFilterModal.classList.remove("active");
        }
      });
    },

    formatOptionText: function (text) {
      var title = text.replace(/\(.+?\)/g, "").trim();
      var price = text.match(/\(.+?\)/g);
      var formattedText = '<span class="title">' + title + "</span>";
      if (price) {
        formattedText += ' <span class="price">' + price.join(" ") + "</span>";
      }
      return formattedText;
    },

    closeAllSelect: function (elmnt) {
      /* A function that will close all select boxes in the document,
      except the current select box: */
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove("select-arrow-active");
          y[i].setAttribute("aria-expanded", "false");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    },

    handleDropdownChange: function (selectors, event) {
      const selectedOptions = [];
      const selectedSizes = [];
      const productSelectorEl = selectors[0].closest(".product-selector-box");
      const panelLabel = productSelectorEl.querySelector(".panel-selection");
      const selectionLabel =
        productSelectorEl.querySelector(".selection-label");
      const fabricContainer = document.querySelector("[data-selected-size]");
      const cushionContainer = document.querySelector(
        "[data-cushion-container]",
      );
      const product = JSON.parse(
        document.querySelector("#product-json").innerHTML,
      );

      const radioSelectors = Array.from(
        productSelectorEl.querySelectorAll('input[type="radio"]:checked'),
      );
      radioSelectors.forEach((radioSelector) => {
        selectedOptions.push({
          radioOption: true,
          productName: radioSelector.name,
          variantTitle: radioSelector.value,
        });
        if (radioSelector.name === "Corner") {
          if (
            !radioSelector.value.includes("Left") &&
            !radioSelector.value.includes("Right")
          ) {
            return;
          }
          const selectedFeature = "ORIENTATION";
          const selectedValue = radioSelector.value.split(" ").pop();
          this.updateCylindoViewer(selectedFeature, selectedValue);
        }
      });

      selectors.forEach((selector) => {
        const selectedOption = selector.options[selector.selectedIndex];
        const productName = selector.dataset.fieldName;
        const variantId = selectedOption.dataset.variantId;
        const value = selectedOption.value;
        selectedOptions.push({
          id: variantId,
          productName,
          variantTitle: value,
        });
        selectedSizes.push({ id: variantId, productName, variantTitle: value });
      });

      function findSizes(selectedSizes, productMetafields) {
        return selectedSizes.map((selectedSize) => {
          const variantTitle = selectedSize.variantTitle;
          const sizeObject = productMetafields.sizes.find((sizeObj) =>
            sizeObj.options.includes(variantTitle),
          );
          return sizeObject ? sizeObject.size : null;
        });
      }

      function determineFinalSize(sizes) {
        const sizeHierarchy = ["Small", "Medium", "Large"];

        const allSame = sizes.every((size) => size === sizes[0]);
        if (allSame) {
          return sizes[0];
        }

        let largestSize = sizes[0];
        sizes.forEach((size) => {
          if (
            sizeHierarchy.indexOf(size) > sizeHierarchy.indexOf(largestSize)
          ) {
            largestSize = size;
          }
        });

        return largestSize;
      }

      const sizes = findSizes(selectedSizes, product.metafields);
      const finalSize = determineFinalSize(sizes);

      fabricContainer.setAttribute("data-selected-size", finalSize);

      let preferredCushionSizeAvailable = false;
      let activeClassAdded = false;

      if (cushionContainer) {
        this.cushionTypes.forEach((product) => {
          product.classList.remove("active");
          if (product.dataset.productSize === finalSize) {
            preferredCushionSizeAvailable = true;
          }
        });

        this.cushionTypes.forEach((product) => {
          const productSize = product.dataset.productSize;
          const selectionContainer = product.closest(".product-selector-box");
          const selectionLabel =
            selectionContainer.querySelector(".panel-selection");
          const showSize =
            !productSize ||
            (preferredCushionSizeAvailable && productSize === finalSize) ||
            (!preferredCushionSizeAvailable &&
              ((finalSize === "Large" && productSize === "Medium") ||
                (finalSize === "Medium" && productSize === "Small")));

          product.style.display = showSize ? "flex" : "none";
          if (showSize && !activeClassAdded) {
            product.classList.add("active");
            selectionLabel.innerText = product.dataset.productLabel;
            activeClassAdded = true;
          }
          if (
            event?.target.id &&
            event?.target.id.includes("size-select") &&
            cushionContainer.classList.contains("active")
          ) {
            cushionContainer.style.maxHeight =
              cushionContainer.scrollHeight + "px";
          }
        });
      }

      const selectedOptionsString = selectedOptions
        .map((option) => {
          let title = option.variantTitle
            .toLowerCase()
            .replace("sofa", "")
            .replace(" inches", '"')
            .trim();

          if (title) {
            title = title
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");

            if (option.radioOption) {
              return title;
            } else {
              let name = option.productName
                .toLowerCase()
                .replace("sofa", "")
                .trim();
              if (name) {
                name = name
                  .replace("*", "")
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");
                return `${name}: ${title}`;
              }
            }
          }
          return "";
        })
        .filter((option) => option)
        .join(", ");

      selectionLabel.innerText = selectedOptionsString;
      panelLabel.innerText = selectedOptionsString;

      this.evaluateTotalPrice();

      this.updateDimensions();
      this.updateSelectionText();
      this.updateStepCompletionStatus();
    },

    toggleBedOpen: function () {
      if (!this.bedToggle) return;
      const open = this.bedToggle.checked;
      this.updateCylindoViewer("ORIENTATION", open ? "BED OPEN" : "SOFA");
    },

    updateCylindoViewer: function (addonType, selectedOption) {
      if (!this.cylindoViewer) return;

      const key = addonType.toLowerCase();
      const current = this.cylindoViewer.features || {};

      // Assigning `features` hands the viewer a new object, so it reloads and
      // fires `loaded` again — and the `loaded` handler re-applies the current
      // fabric and leg, which assigns `features`, which reloads... Writing only
      // on an actual change breaks that cycle at the source.
      if (current[key] === selectedOption) return;

      this.cylindoViewer.features = {
        ...current,
        [key]: selectedOption,
      };
    },

    /**
     * Extracted so it can be rebound after setCylindoModel() replaces the viewer
     * element (see the ottoman style step below).
     */
    bindCylindoErrorHandler: function (viewer) {
      if (!viewer) return;

      viewer.addEventListener("error", (event) => {
        const errorMessage = event.detail.error?.message;
        if (!errorMessage) {
          return;
        }

        console.warn("Cylindo could not render a selection:", errorMessage);

        if (errorMessage.includes("LEG TYPE")) {
          if (viewer.features) {
            const { ["LEG TYPE"]: removedLeg, ...remainingFeatures } =
              viewer.features;
            // Remember the rejection before clearing it. Stripping the feature
            // reloads the viewer, and without this the `loaded` handler would
            // put the same bad leg straight back.
            const code = viewer.getAttribute("code");
            if (code && removedLeg) {
              if (!this.rejectedCylindoLegs) this.rejectedCylindoLegs = new Set();
              this.rejectedCylindoLegs.add(
                `${code}|${this.normalizeCylindoValue(removedLeg)}`,
              );
            }
            viewer.features = remainingFeatures;
          }
        }
      });
    },

    /* ---------------------------------------------------------------------
       Viewer messaging

       One notice sits above the viewer at a time, but three things can raise
       it, so the reasons are held separately and rendered together. Otherwise
       clearing a leg error would also wipe a fabric notice that is still true.
       --------------------------------------------------------------------- */

    setCylindoMessage: function (kind, message) {
      if (!this.cylindoMessageState) this.cylindoMessageState = {};
      if (this.cylindoMessageState[kind] === (message || null)) return;
      this.cylindoMessageState[kind] = message || null;
      this.renderCylindoMessage();
    },

    renderCylindoMessage: function () {
      const state = this.cylindoMessageState || {};
      // Most-blocking first: no model at all outranks a fabric or leg the
      // model happens not to carry.
      const message = ["model", "fabric", "legs"]
        .map((kind) => state[kind])
        .find(Boolean);
      const viewer = this.cylindoViewer;
      // Inside .bed-toggle-viewer-wrap, which is the positioning context the
      // notice is pinned against - it overlays the top of the render.
      const anchor = viewer;
      const existing = document.querySelector(".cylindo-error-message");

      if (!message || !anchor || !anchor.parentNode) {
        if (existing) existing.remove();
        return;
      }

      if (existing) {
        existing.textContent = message;
        return;
      }

      const errorDiv = document.createElement("div");
      errorDiv.className = "cylindo-error-message";
      // Announced rather than alerted: the selection still went through, only
      // the preview did not follow.
      errorDiv.setAttribute("role", "status");
      errorDiv.textContent = message;
      // AFTER the viewer, not before. <cylindo-viewer> is `position: relative`
      // with no z-index, so it never opens a stacking context of its own and
      // its internals - the zoom buttons are `z-index: 5` - land in this same
      // one. Painting order breaks ties by document order, so a notice placed
      // ahead of the viewer loses to them and is simply never seen.
      anchor.parentNode.insertBefore(errorDiv, anchor.nextSibling);

      console.info("Cylindo preview notice:", message);
    },

    /* ---------------------------------------------------------------------
       Ottoman style step

       Cylindo has no generic ottoman model - every model is style-specific -
       so the consolidated ottoman PDP boots the viewer on a default style and
       swaps the model as the customer picks. The chosen style also decides
       which legs are offered and, crucially, which variant is added to cart:
       the form's `id` input is repointed at that style's own product, so the
       order line reads "Daphne Ottoman" exactly as it did when each style had
       its own PDP. That keeps the Cart Transform Function - which is variant
       agnostic - untouched.

       Only runs when snippets/sofa-builder.liquid emitted #ottoman-style-data.
       --------------------------------------------------------------------- */

    initOttomanStyle: function () {
      const dataEl = document.getElementById("ottoman-style-data");
      if (!dataEl) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (error) {
        console.error("Ottoman style data is not valid JSON", error);
        return;
      }
      if (!data || !Array.isArray(data.styles) || data.styles.length === 0) {
        return;
      }

      this.ottomanStyles = data.styles;
      this.ottomanStyleTiles = Array.from(
        this.container.querySelectorAll(".ottoman-style_option"),
      );
      if (this.ottomanStyleTiles.length === 0) return;

      // Real <button>s, so Enter and Space come for free.
      this.ottomanStyleTiles.forEach((tile) => {
        tile.addEventListener("click", () => {
          this.selectOttomanStyle(tile);
        });
      });

      const initialTile =
        this.ottomanStyleTiles.find((tile) =>
          tile.classList.contains("active"),
        ) || this.ottomanStyleTiles[0];

      // Liquid already rendered the viewer against this style's code, so don't
      // tear it down and rebuild it just to arrive at the same place.
      this.selectOttomanStyle(initialTile, { skipViewer: true });
    },

    selectOttomanStyle: function (tile, options) {
      const opts = options || {};
      const entry = (this.ottomanStyles || []).find(
        (style) => style.name === tile.dataset.styleName,
      );
      if (!entry) return;

      this.activeOttomanStyle = entry;
      this.ottomanStyleTiles.forEach((other) => {
        const isActive = other === tile;
        other.classList.toggle("active", isActive);
        other.setAttribute("aria-pressed", String(isActive));
      });

      const styleBox = tile.closest(".product-selector-box");
      if (styleBox) {
        const panelLabel = styleBox.querySelector(".panel-selection");
        if (panelLabel) panelLabel.innerText = entry.name;
        styleBox.classList.remove("enavi_option_error");
      }

      this.applyOttomanVariant(entry);
      this.updateOttomanLegPopup(entry);

      this.filterOttomanLegs(entry);

      if (!opts.skipViewer) {
        // Not every style has a Cylindo model yet. Swapping to one that does
        // not exist leaves the viewer 404-ing a frame per angle, so confirm it
        // is there first and otherwise keep showing the last model that worked.
        this.loadCylindoConfig(entry.cylindoCode).then((config) => {
          if (this.activeOttomanStyle?.name !== entry.name) return;
          if (!config) {
            console.warn(
              `No Cylindo model for ${entry.cylindoCode}; keeping the current preview.`,
            );
            // Keeping the last good render means the customer is looking at a
            // DIFFERENT style than the one they just picked, so say so. Only on
            // a definite 404 - a request that merely failed proves nothing.
            if (this.cylindoMissingModels?.has(entry.cylindoCode)) {
              this.setCylindoMessage("model", cylindoMessages.style);
            }
            return;
          }
          this.setCylindoModel(entry.cylindoCode);
        });
      }

      const styleText = document.querySelector(".sofa-builder-selection-style");
      if (styleText) styleText.textContent = entry.name;

      this.evaluateTotalPrice();
      this.updateStepCompletionStatus();
    },

    /**
     * Repoint the add-to-cart form at the selected style's own variant. This is
     * what makes the order line item the style product rather than the umbrella
     * "Custom Matching Ottoman".
     */
    applyOttomanVariant: function (entry) {
      if (!entry.variantId) return;

      if (this.form) {
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.value = entry.variantId;
      }

      if (this.container && entry.productId) {
        this.container.dataset.mainProductId = entry.productId;
      }

      const price = parseInt(entry.price, 10);
      if (!isNaN(price)) {
        this.basePrice = price;
      }
    },

    /**
     * The accordion owns a box's maxHeight, overflow and inert, all keyed off its
     * `active` class. handleProductSelection() also writes maxHeight, which is
     * harmless when a customer clicks inside an already-open box but leaves a
     * CLOSED box expanded-yet-inert when we select programmatically - legs that
     * render but cannot be clicked. Put the box back in step with its state.
     */
    syncAccordionState: function (selectorBox) {
      if (!selectorBox) return;
      const boxContent = selectorBox.querySelector(".box-content");
      if (!boxContent) return;

      const isOpen = selectorBox.classList.contains("active");
      boxContent.style.maxHeight = isOpen ? boxContent.scrollHeight + "px" : "0";
      boxContent.inert = !isOpen;
    },

    /**
     * Every style's legs are rendered up front and tagged with data-ottoman-style;
     * show only the selected style's. getAddonItems() collects `.enavi_addon.active`
     * regardless of visibility (only the Cushions box gets a visibility filter), so
     * a leg left active on a hidden style would be billed and sent to Cylindo. The
     * selection is therefore always reset to a leg belonging to the new style.
     */
    filterOttomanLegs: function (entry) {
      const legBox = this.container.querySelector('[data-selector-type="Legs"]');
      const legContainer = legBox?.querySelector(".leg-container");
      if (!legContainer) return;

      const allLegs = Array.from(
        legContainer.querySelectorAll(".leg_option[data-ottoman-style]"),
      );
      if (allLegs.length === 0) return;

      const styleLegs = [];
      allLegs.forEach((leg) => {
        const belongs = leg.dataset.ottomanStyle === entry.name;
        leg.style.display = belongs ? "" : "none";
        leg.classList.remove("active");
        if (belongs) styleLegs.push(leg);
      });

      // Keep the cached list in sync - handleCylindoDefaultFeatures and the
      // click handlers both read it.
      this.legProducts = allLegs;

      if (styleLegs.length === 0) {
        const panelLabel = legBox?.querySelector(".panel-selection");
        if (panelLabel) panelLabel.innerText = "Choose Legs";
        this.syncAccordionState(legBox);
        return;
      }

      if (styleLegs.length === 1) {
        // Nothing to choose, so pick it automatically rather than forcing the
        // customer to open the step and click the only option. syncAccordionState
        // undoes the box-content expansion handleProductSelection() causes, so
        // this doesn't pop the step open.
        this.handleProductSelection(styleLegs[0], this.legProducts);
        this.syncAccordionState(legBox);
        this.preferRenderableLeg(entry, styleLegs, legBox);
        return;
      }

      // Deliberately left unselected. The step should read as "not done yet"
      // so the customer makes a real choice, rather than opening pre-ticked on
      // whichever leg happens to be first.
      const legPanelLabel = legBox?.querySelector(".panel-selection");
      if (legPanelLabel) legPanelLabel.innerText = "Choose Legs";
      this.updateStepCompletionStatus();
      this.syncAccordionState(legBox);

      // Not every leg the style sells has Cylindo imagery. Those stay on offer
      // and show a preview notice when picked; this only steers the initial
      // selection towards one the model can actually draw.
      this.preferRenderableLeg(entry, styleLegs, legBox);
    },

    /**
     * Cylindo's per-model configuration lists the LEG TYPE options it can render.
     * Public JSON on the same CDN as the viewer, and cached per model.
     */
    /**
     * Cylindo's per-model configuration. Public JSON on the same CDN as the
     * viewer, cached per model. Resolves to null when the model does not exist
     * or the request fails.
     */
    loadCylindoConfig: function (code) {
      if (!this.cylindoConfigs) this.cylindoConfigs = {};
      if (this.cylindoConfigs[code]) return this.cylindoConfigs[code];

      // No fetch, no lookup — and crucially no throw. This runs inside a click
      // handler, where an exception would abandon the rest of the style switch
      // silently.
      if (typeof fetch !== "function") {
        this.cylindoConfigs[code] = Promise.resolve(null);
        return this.cylindoConfigs[code];
      }

      const customerId =
        this.cylindoViewer?.getAttribute("customer-id") || "6899";
      const url = `https://content.cylindo.com/api/v2/${customerId}/products/${code}/configuration`;

      this.cylindoConfigs[code] = fetch(url)
        .then((response) => {
          // A 404 is Cylindo saying the model does not exist, which is a
          // different thing from a request that failed. Only the former is
          // certain enough to tell the customer there is nothing to preview -
          // a network blip must never claim a product has no imagery.
          if (response.status === 404) {
            if (!this.cylindoMissingModels) {
              this.cylindoMissingModels = new Set();
            }
            this.cylindoMissingModels.add(code);
            return null;
          }
          return response.ok ? response.json() : null;
        })
        .catch(() => null);

      return this.cylindoConfigs[code];
    },

    /**
     * Our option labels are title case with spaces ("Merit Onyx"); Cylindo's
     * codes are upper case and inconsistently separated ("MERIT-ONYX",
     * "APOLLO CLOVER"). Compare them on a form neither side can vary.
     */
    normalizeCylindoValue: function (value) {
      return String(value || "")
        .toUpperCase()
        .trim()
        .replace(/[\s_-]+/g, "-");
    },

    /** The model the viewer is showing right now. */
    currentCylindoCode: function () {
      return this.cylindoViewer?.getAttribute("code") || "";
    },

    /**
     * The options a model can render for one feature, or null when that is
     * unknown (missing model, failed request, feature absent from the config).
     */
    loadCylindoFeatureSupport: function (code, feature) {
      const key = `${code}|${feature}`;
      if (!this.cylindoFeatureSupport) this.cylindoFeatureSupport = {};
      if (this.cylindoFeatureSupport[key]) return this.cylindoFeatureSupport[key];

      this.cylindoFeatureSupport[key] = this.loadCylindoConfig(code).then(
        (config) => {
          const entry = (config?.features || []).find(
            (f) => f.code === feature,
          );
          const supported = entry
            ? new Set(
                (entry.options || []).map((o) =>
                  this.normalizeCylindoValue(o.code),
                ),
              )
            : null;
          // Cached synchronously too, so legIsRenderable() can answer without
          // awaiting on the hot path where a leg is about to be pushed.
          if (!this.cylindoSupportResolved) this.cylindoSupportResolved = {};
          this.cylindoSupportResolved[key] = supported;
          return supported;
        },
      );

      return this.cylindoFeatureSupport[key];
    },

    /** The LEG TYPE options a model can render, or null if that is unknown. */
    loadCylindoLegSupport: function (code) {
      return this.loadCylindoFeatureSupport(code, "LEG TYPE");
    },

    /**
     * Whether the active model can draw this leg.
     *
     * Pushing a leg Cylindo has no imagery for is not merely a bad preview: the
     * viewer errors, the error handler strips LEG TYPE, stripping it reloads
     * the viewer, `loaded` re-applies the leg, and round it goes. Merced hit
     * this because its only leg is spelled "450 Espresso" against Cylindo's
     * "045 ESPRESSO", so nothing it offered was renderable.
     *
     * Answers true whenever support is unknown, so sofas and any model we could
     * not look up behave exactly as before.
     */
    legIsRenderable: function (label) {
      const code = this.currentCylindoCode();
      if (!code || !label) return true;

      const normalized = this.normalizeCylindoValue(label);
      if (this.rejectedCylindoLegs?.has(`${code}|${normalized}`)) return false;

      const supported = this.cylindoSupportResolved?.[`${code}|LEG TYPE`];
      if (!supported || supported.size === 0) return true;
      return supported.has(normalized);
    },

    /** The fabric the customer is on. Decide Later is not a fabric. */
    activeFabricValue: function () {
      const el = document.querySelector(
        '[data-selector-type="Fabric"] .enavi_addon.active:not(.fabric-samples-decide-later)',
      );
      return el ? el.dataset.cylindoValue || el.dataset.productLabel : "";
    },

    /**
     * Re-state what can and cannot be previewed on the model now in the viewer.
     * Runs at boot and after every ottoman style swap, because a model that
     * cannot draw the current fabric - or does not exist at all - is a property
     * of the model, not of the click that got us here.
     */
    refreshCylindoAvailability: function () {
      if (!this.cylindoViewer || typeof fetch !== "function") return;

      const code = this.currentCylindoCode();
      if (!code) return;

      this.loadCylindoConfig(code).then(() => {
        // The customer may have moved to another style while this was in
        // flight; that style runs its own sweep.
        if (this.currentCylindoCode() !== code) return;

        const missing = !!this.cylindoMissingModels?.has(code);
        this.setCylindoMessage(
          "model",
          missing
            ? this.activeOttomanStyle
              ? cylindoMessages.style
              : cylindoMessages.model
            : null,
        );
      });

      // Message only: mid-swap the viewer is still loading the new model, and
      // its `loaded` handler does the pushing.
      this.applyFabricToViewer(this.activeFabricValue(), { push: false });
    },

    /**
     * Push a fabric to the viewer only if the model can actually draw it.
     *
     * New fabrics go on sale before Cylindo has modelled them on every product,
     * so this is the ordinary case, not a failure: leave the last good render
     * up and tell the customer the preview has not caught up yet. Pushing it
     * anyway would ask the viewer for frames that 404 on every angle.
     */
    applyFabricToViewer: function (label, options) {
      const push = options?.push !== false;

      // No fabric chosen yet (the swatches load asynchronously), so there is
      // nothing to claim is unavailable.
      if (!label) {
        this.setCylindoMessage("fabric", null);
        return;
      }

      const code = this.currentCylindoCode();
      if (!code || typeof fetch !== "function") {
        this.setCylindoMessage("fabric", null);
        if (push) this.updateCylindoViewer("UPHOLSTERY", label);
        return;
      }

      // Only the newest selection may write; the configuration request is in
      // flight long enough for the customer to click again.
      this.pendingFabricValue = label;

      this.loadCylindoFeatureSupport(code, "UPHOLSTERY").then((supported) => {
        if (this.pendingFabricValue !== label) return;
        if (this.currentCylindoCode() !== code) return;

        // Unknown support is not the same as no support: on a failed or empty
        // lookup push the fabric and let the viewer speak for itself.
        const renderable =
          !supported ||
          supported.size === 0 ||
          supported.has(this.normalizeCylindoValue(label));

        if (!renderable) {
          this.setCylindoMessage("fabric", cylindoMessages.fabric);
          return;
        }

        this.setCylindoMessage("fabric", null);
        if (push) this.updateCylindoViewer("UPHOLSTERY", label);
      });
    },

    /** Push a leg to the viewer only if the model can actually draw it. */
    applyLegToViewer: function (label) {
      if (!label) return;

      // The leg stays selected and orderable; only the preview cannot follow.
      // Pushing it anyway makes the viewer request a frame per angle and 404 on
      // every one, so say so rather than sending it.
      if (!this.legIsRenderable(label)) {
        this.setCylindoMessage("legs", cylindoMessages.legs);
        return;
      }
      this.setCylindoMessage("legs", null);

      // Only push to a viewer already showing this style's model. Mid-switch it
      // still shows the OUTGOING one, which generally cannot draw the incoming
      // style's legs; setCylindoModel() applies the leg once the new model
      // reports `loaded`.
      const code = this.activeOttomanStyle?.cylindoCode;
      if (code && this.cylindoViewer?.getAttribute("code") !== code) return;
      this.updateCylindoViewer("LEG TYPE", label);
    },

    /**
     * Every leg the style sells stays on offer, including any the model cannot
     * draw — the page already has a notice for exactly that case, and hiding a
     * sellable leg costs an order. All this does is prefer a renderable leg for
     * the initial selection, so the step does not open on a notice.
     */
    preferRenderableLeg: function (entry, styleLegs, legBox) {
      if (typeof fetch !== "function") return;

      this.loadCylindoLegSupport(entry.cylindoCode).then((supported) => {
        // Unknown support is not the same as no support.
        if (!supported || supported.size === 0) return;
        // The customer may have moved on while this was in flight.
        if (this.activeOttomanStyle?.name !== entry.name) return;

        const label = (el) =>
          this.normalizeCylindoValue(el?.dataset.productLabel);
        const renderable = styleLegs.filter((leg) => supported.has(label(leg)));
        const unrenderable = styleLegs
          .filter((leg) => !supported.has(label(leg)))
          .map((leg) => leg.dataset.productLabel);

        if (unrenderable.length) {
          console.warn(
            `No Cylindo model on ${entry.cylindoCode} for: ${unrenderable.join(", ")}. ` +
              `Still selectable; the preview shows a notice instead.`,
          );
        }

        // Only ever corrects a choice already made - it must not create one,
        // or the step would tick itself on load.
        const active = styleLegs.find((leg) => leg.classList.contains("active"));
        if (!active) return;

        if (supported.has(label(active))) return;

        if (renderable.length) {
          this.handleProductSelection(renderable[0], this.legProducts);
        } else {
          // Nothing renderable at all: keep the selection and say so.
          this.applyLegToViewer(
            active.dataset.cylindoValue || active.dataset.productLabel,
          );
        }

        this.syncAccordionState(legBox);
      });
    },

    /**
     * The leg info page differs per style, so one modal per distinct page is
     * rendered and the opener is retargeted here.
     */
    updateOttomanLegPopup: function (entry) {
      const opener = this.container.querySelector("[data-ottoman-leg-popup]");
      if (!opener) return;

      if (entry.legPopupId && document.querySelector(entry.legPopupId)) {
        opener.dataset.modal = entry.legPopupId;
        opener.style.display = "";
      } else {
        opener.style.display = "none";
      }
    },

    /**
     * Swap the Cylindo model. <cylindo-viewer> is not documented to react to its
     * `code` attribute changing, so the element is replaced outright and the
     * listeners rebound. Current fabric and leg selections are re-applied once the
     * new model reports `loaded`.
     */
    setCylindoModel: function (code) {
      const current = this.cylindoViewer;
      if (!current || !code || current.getAttribute("code") === code) return;

      // cloneNode carries the attributes and the light-DOM children
      // (<cylindo-360>, the frame tags, the thumbnail bar); the shadow root and
      // the `features` property are rebuilt when the clone is upgraded, which is
      // why the current selections are re-applied on `loaded` below.
      const replacement = current.cloneNode(true);
      replacement.setAttribute("code", code);

      this.cylindoMessageState = {};
      this.renderCylindoMessage();

      replacement.addEventListener("loaded", () => {
        // ":not(.fabric-samples-decide-later)" because Decide Later is an
        // .enavi_addon in the same step, and its label is not a fabric.
        const activeFabric = document.querySelector(
          '[data-selector-type="Fabric"] .enavi_addon.active:not(.fabric-samples-decide-later)',
        );
        if (activeFabric) {
          this.applyFabricToViewer(
            activeFabric.dataset.cylindoValue ||
              activeFabric.dataset.productLabel,
          );
        }

        // Only re-apply a leg this model can draw. Re-applying one it cannot
        // is what turned a single Cylindo error into an endless reload.
        const activeLeg = document.querySelector(
          '[data-selector-type="Legs"] .enavi_addon.active',
        );
        const activeLegLabel =
          activeLeg?.dataset.cylindoValue || activeLeg?.dataset.productLabel;
        if (activeLegLabel && this.legIsRenderable(activeLegLabel)) {
          this.updateCylindoViewer("LEG TYPE", activeLegLabel);
        } else {
          this.handleCylindoDefaultFeatures();
        }

        // The customizer restyles the viewer's shadow DOM, which only exists
        // once the replacement has been upgraded and loaded.
        if (typeof window.refreshCylindoViewerCustomizer === "function") {
          window.refreshCylindoViewerCustomizer();
        }
      });

      this.bindCylindoErrorHandler(replacement);

      current.replaceWith(replacement);
      this.cylindoViewer = replacement;

      // Now that the viewer carries the new code, ask what this model can draw.
      this.refreshCylindoAvailability();
    },

    handleProductSelection: function (el, allProducts, silent) {
      const selectionContainer = el.closest(".product-selector-box");
      const boxContent = selectionContainer.querySelector(".box-content");
      const panelLabel = selectionContainer.querySelector(".panel-selection");
      const selectionLabel =
        selectionContainer.querySelector(".selection-label");
      const selectionDesc = selectionContainer.querySelector(".selection-desc");
      const selectionImg = selectionContainer.querySelector(".selection-img");
      const headingImg = selectionContainer.querySelector(".heading-img");
      const addonType = selectionContainer.dataset.selectorType;
      const viewer = document.querySelector("cylindo-viewer");
      if (addonType === "Fabric") {
        // Gated: a fabric the model has no imagery for gets a notice rather
        // than a broken render. See applyFabricToViewer().
        this.applyFabricToViewer(
          el.dataset.cylindoValue || el.dataset.productLabel,
        );
        let format =
          window.theme.settings.money_with_currency_format || "${{amount}}";
        document.querySelector(".pdp-fabric-price-tag").innerHTML =
          `+${formatMoney(el.dataset.productPrice, format)}`;
        if (!el.classList.contains("fabric-samples-decide-later")) {
          this.clearDecideLater();
        }
      }

      if (addonType === "Legs") {
        // Gated: a leg the model cannot draw sends the viewer into an
        // error/reload cycle. See legIsRenderable().
        this.applyLegToViewer(el.dataset.cylindoValue || el.dataset.productLabel);
      }

      panelLabel.innerText = el.dataset.productLabel;
      if (selectionLabel) {
        selectionLabel.innerText = el.dataset.productLabel;
      }

      if (selectionImg && el.dataset.productImage) {
        selectionImg.onload = () => {
          if (!silent) {
            boxContent.style.maxHeight = `${boxContent.scrollHeight}px`;
          }
        };
        selectionImg.src = el.dataset.productImage;
      }

      if (headingImg && el.dataset.productImage) {
        headingImg.src = el.dataset.productImage;
        if (headingImg.srcset) {
          headingImg.srcset = el.dataset.productImage;
        }
      }

      if (selectionDesc && el.dataset.productDesc) {
        selectionDesc.innerHTML = el.dataset.productDesc;
      } else if (selectionDesc) {
        selectionDesc.innerHTML = "";
      }

      if (selectionContainer.classList.contains("enavi_option_error")) {
        selectionContainer.classList.remove("enavi_option_error");
      }

      if (!silent) {
        boxContent.style.maxHeight = `${boxContent.scrollHeight}px`;
      }

      allProducts.forEach((product) => {
        product.classList.remove("active");
      });
      el.classList.add("active");

      this.evaluateTotalPrice();

      this.updateSelectionText();
      this.updateStepCompletionStatus();
    },

    handleAtc: function () {
      if (this.postDisabled) {
        return;
      }
      this.postDisabled = true;

      this.prepareAndPostFormData();
    },

    prepareAndPostFormData: async function () {
      this.allItems = await this.getAllItems();

      if (!this.checkIfRequiredAddonSelected(this.allItems)) {
        this.postDisabled = false;
        return;
      }

      // Safety net: the ottoman's cart line is the selected style's variant, and
      // nothing else on the page should be writing to this input. Re-assert it
      // rather than trust that no other handler moved it.
      if (this.activeOttomanStyle) {
        this.applyOttomanVariant(this.activeOttomanStyle);
      }

      this.emitSubmitEvent();
    },

    getAllItems: function () {
      // Remove only addon line item props (not slider properties)
      const addonLineProps = this.selectAll(".addon-line-item-prop");

      addonLineProps.forEach((el) => {
        el.remove();
      });

      const addonItems = this.getAddonItems();
      if (addonItems.length > 0) {
        this.addParentLineItemProperties(addonItems);
      }

      // Don't remove sofa-slider-property inputs - they're managed by the slider

      return addonItems;
    },

    emitSubmitEvent: function () {
      setTimeout(
        function () {
          this.addToCart.disabled = false;
          this.addToCart.setAttribute("data-disable-atc", "false");
          this.addToCart.type = "submit";
          this.addToCart.click();
          this.addToCart.setAttribute("data-disable-atc", "true");
          this.addToCart.type = "button";
          this.postDisabled = false;
        }.bind(this),
        100,
      );
    },

    addAlltemsToCart: function () {
      const filteredItems = this.allItems.filter(
        (item) => item.id !== undefined,
      );

      const data = { items: filteredItems };
      const self = this;

      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/cart/add.js");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            self.emitSubmitEvent();
          } else {
            alert(
              "An error occurred while adding items to cart: " + xhr.status,
            );
            self.postDisabled = false;
          }
        }
      };
      xhr.send(JSON.stringify(data));
      this.allItems = [];
    },

    addParentLineItemProperties: function (addonItems) {
      var lineItemProps = {
        _addon_products: [],
      };
      addonItems.forEach((item) => {
        lineItemProps[item.addon_type] = item.title;
        if (item.id) {
          let _variant = `${item.id}${
            isNaN(Number(item.price)) ? "_0" : `_${item.price}`
          }`;

          lineItemProps["_addon_products"].push(_variant);
        }
        if (item.parentLineItem == "true") {
          Object.entries(item.properties).map(function (property) {
            if (!property[0].startsWith("_")) {
              lineItemProps[property[0]] = property[1];
              delete item.properties[property[0]];
            }
          });
        }
      });

      // Ottoman styles are usually drafts, so the cart line is the umbrella
      // "Custom Matching Ottoman" product; record which style was picked.
      if (this.activeOttomanStyle) {
        lineItemProps["Style"] = this.activeOttomanStyle.name;
      }

      for (let propName in lineItemProps) {
        const propNode = this.form.querySelector(
          '[name="properties[' + propName + ']"]',
        );
        if (propNode) {
          propNode.value = lineItemProps[propName];
        } else {
          const input = document.createElement("input");
          input.type = "hidden";
          input.className = "addon-line-item-prop";
          input.name = "properties[" + propName + "]";
          input.value = lineItemProps[propName];
          this.form.appendChild(input);
        }
      }
    },

    getAddonItems: function () {
      var addonItems = [];

      // Skip cushion options the React slider owns: it computes the counts and
      // writes properties[Seat Cushions] itself, so collecting them here would
      // double up.
      //
      // Keyed on the marker Liquid sets, NOT on visibility. It used to test
      // display:none, which meant hiding the Cushions box for any other reason
      // — an ottoman, whose single "Standard" option needs no step — silently
      // dropped the property from the order.
      var isInsideHiddenCushionSelector = function (element) {
        var parentBox = element.closest(".product-selector-box");
        if (!parentBox) return false;

        return (
          parentBox.getAttribute("data-selector-type") === "Cushions" &&
          (parentBox.hasAttribute("data-cushions-owned-by-slider") ||
            parentBox.id === "product-cushions-box-hide")
        );
      };

      // Collect cushion/firmness/leg addon items (skip hidden cushions)
      var selectedAddons = Array.from(
        this.container.querySelectorAll(".enavi_addon.active"),
      )
        .filter((item) => !isInsideHiddenCushionSelector(item)) // Skip cushion items if hidden
        .map((item) => {
          var properties = {
            _addon_product: true,
            _general_product_id: this.container.dataset.mainProductId,
            _properties_value: item.dataset.productLabel,
          };
          if (item.dataset.decideLater === "true") {
            properties._decide_later = true;
          }
          return {
            id: item.dataset.variantId,
            quantity: 1,
            price: item.dataset.productPrice ?? "0",
            title: item.dataset.productLabel,
            addon_type: item.parentElement.dataset.addonType,
            properties: properties,
            parentLineItem: item.hasAttribute("data-parent-line")
              ? "true"
              : undefined,
          };
        });

      // Collect ALL dropdown addons (including depth/size - slider updates these)
      var dropdownAddons = Array.from(
        this.container.querySelectorAll(".enavi-selector_addon"),
      ).map((item) => {
        var selectedOption = item.options[item.selectedIndex];
        return {
          id: selectedOption.dataset.variantId,
          quantity: 1,
          price: selectedOption.dataset.productPrice ?? "0",
          title: item.value,
          addon_type: item.parentElement.dataset.addonType,
          properties: {
            _addon_product: true,
            _general_product_id: this.container.dataset.mainProductId,
            _properties_value: item.value,
          },
          parentLineItem: selectedOption.hasAttribute("data-parent-line")
            ? "true"
            : undefined,
        };
      });

      // Collect ALL radio addons
      var radioAddons = Array.from(
        this.container.querySelectorAll(".radio-option"),
      ).map((item) => {
        var selectedOption = item.querySelector('input[type="radio"]:checked');
        return {
          id: selectedOption.dataset.variantId,
          quantity: 1,
          title: selectedOption.value,
          addon_type: selectedOption.name,
          properties: {
            _addon_product: true,
            _general_product_id: this.container.dataset.mainProductId,
            _properties_value: selectedOption.value,
          },
          parentLineItem: selectedOption.hasAttribute("data-parent-line")
            ? "true"
            : undefined,
        };
      });

      addonItems = radioAddons.concat(dropdownAddons).concat(selectedAddons);

      return addonItems;
    },

    getAddonLineItemProperties: function (item) {
      var properties = {};
      this.selectAll(
        '.addon_property[data-variant-id="' + item.value + '"]',
      ).forEach(function (propertyNode) {
        if (
          (propertyNode.type === "text" && propertyNode.value) ||
          propertyNode.checked === true
        ) {
          properties[propertyNode.name] = propertyNode.value;
        }
      });
      return properties;
    },

    evaluateTotalPrice: function () {
      const addonElements = Array.from(
        document.querySelectorAll(".enavi_addon.active"),
      );
      const selectorElements = Array.from(
        document.querySelectorAll(".enavi-selector_addon"),
      );

      const addonPrices = addonElements.map((element) => {
        const price = parseInt(element.getAttribute("data-product-price"));
        return isNaN(price) ? 0 : price;
      });

      const selectorPrices = selectorElements.map((element) => {
        const selectedIndex = element.selectedIndex;
        const selectedOption = element.options[selectedIndex];
        const price = parseInt(
          selectedOption.getAttribute("data-product-price"),
        );
        return isNaN(price) ? 0 : price;
      });

      const totalPrice =
        this.basePrice +
        addonPrices.reduce((a, b) => a + b, 0) +
        selectorPrices.reduce((a, b) => a + b, 0);
      let format =
        window.theme.settings.money_with_currency_format || "${{amount}}";
      var priceText = formatMoney(totalPrice, format);
      this.atcPrice.innerText = priceText;
      this.productPriceEls.forEach((el) => (el.innerText = priceText));

      //Refresh Affirm UI
      try {
        document
          .querySelector(".affirm-as-low-as")
          .setAttribute("data-amount", totalPrice);
        affirm.ui.refresh();
      } catch (error) {
        console.log("Affirm not found");
      }
    },

    checkIfRequiredAddonSelected: function (allItems) {
      const emptyRequiredOptions = this.requiredAddons.filter(
        (addon) => !this.isRequiredAddonSatisfied(addon),
      );

      this.requiredAddons.forEach((addon) => {
        addon.classList.toggle(
          "enavi_option_error",
          emptyRequiredOptions.includes(addon),
        );
      });

      if (emptyRequiredOptions.length) {
        this.select(".enavi-error-message")?.classList.add("active");
      } else {
        this.select(".enavi-error-message")?.classList.remove("active");
      }
      return emptyRequiredOptions.length === 0;
    },

    /**
     * Whether a required step has been answered. Shared by Add-to-Cart
     * validation and by the pass that clears an error once the customer fixes
     * it, so the two can never disagree about what "answered" means.
     */
    isRequiredAddonSatisfied: function (addon) {
      // Hidden steps are owned by the slider, or not applicable at all.
      const hidden = (el) =>
        el &&
        (el.id === "product-cushions-box-hide" ||
          el.id === "product-depth-box-hide" ||
          (el.style && el.style.display === "none"));

      if (hidden(addon) || hidden(addon.closest(".product-selector-box"))) {
        return true;
      }

      if (addon.classList.contains("enavi-selector-addon")) {
        return !!addon.querySelector("option:checked");
      }

      if (!addon.classList.contains("product-selector-box")) return true;

      const selectorType = addon.dataset.selectorType;

      if (selectorType === "Size") {
        // Judged by its dropdowns, the same way updateStepCompletionStatus
        // does. The ottoman leaves this unset until the customer picks a size,
        // so it has to block Add to Cart rather than shipping an ottoman with
        // no dimensions.
        const selects = Array.from(addon.querySelectorAll("select"));
        return (
          selects.length > 0 &&
          selects.every((select) => select.selectedIndex > 0)
        );
      }

      // The ottoman style step is a required box whose tiles are deliberately
      // not `.enavi_addon` - that class would make getAddonItems() bill the
      // style a second time - so it needs its own selector here.
      const activeSelector =
        selectorType === "Style"
          ? ".ottoman-style_option.active"
          : ".enavi_addon.active";
      return !!addon.querySelector(activeSelector);
    },

    /**
     * Clear the error on any step the customer has since answered.
     *
     * Only ever clears. Errors are raised by Add to Cart, so a step must not
     * start shouting merely because it has not been reached yet — but once it
     * is answered the red state has to go without waiting for another submit.
     */
    clearSatisfiedAddonErrors: function () {
      if (!this.requiredAddons) return;

      let outstanding = 0;
      this.requiredAddons.forEach((addon) => {
        if (this.isRequiredAddonSatisfied(addon)) {
          addon.classList.remove("enavi_option_error");
        } else if (addon.classList.contains("enavi_option_error")) {
          outstanding += 1;
        }
      });

      if (outstanding === 0) {
        this.select(".enavi-error-message")?.classList.remove("active");
      }
    },

    updateFabricMaterialPopups: function (modal, product) {
      modal.innerHTML = "";
      const img = document.createElement("img");
      img.classList.add("material-img");
      img.src = product.dataset.productImage;
      const materialLabel = document.createElement("div");
      materialLabel.classList.add("material-label");
      materialLabel.innerText = product.dataset.productLabel;
      const materialDesc = document.createElement("div");
      materialDesc.classList.add("material-desc");
      materialDesc.innerHTML = `<p>${product.dataset.productDesc}</p>`;
      modal.appendChild(img);
      modal.appendChild(materialLabel);
      modal.appendChild(materialDesc);
      let modalContent = modal.closest(".product-popup-modal__content");
      if (
        modalContent &&
        modalContent.querySelector(".product-popup-modal__content-header h4")
      ) {
        modalContent.querySelector(
          ".product-popup-modal__content-header h4",
        ).innerText = product.dataset.productLabel;
      }
    },

    handleCylindoDefaultFeatures: function () {
      if (!this.cylindoViewer) return;

      const defaultFeatures = this.cylindoViewer.features;

      // URL-provided selections win over Cylindo viewer defaults
      // (see assets/sofa-config-url.js).
      const urlHas = (key) =>
        !!(window.SofaConfigUrl && window.SofaConfigUrl.has(key));

      if (defaultFeatures) {
        if (defaultFeatures.upholstery && !urlHas("fabric")) {
          this.defaultFabric = defaultFeatures.upholstery;
          this.applyDefaultFabric();
        }

        // Not on the ottoman: the Legs step is meant to open unselected there,
        // and back-selecting Cylindo's default would tick it on load.
        if (
          defaultFeatures["leg type"] &&
          !urlHas("legs") &&
          !this.activeOttomanStyle
        ) {
          const legName = defaultFeatures["leg type"].replace(/-/g, " ");
          // On the ottoman every style's legs are in the DOM at once, so only
          // consider the ones the selected style actually offers.
          const legOption = this.legProducts
            .filter((product) => product.style.display !== "none")
            .find((product) => {
              const productLabel = product.dataset.productLabel?.toLowerCase();
              return (
                productLabel && productLabel.includes(legName.toLowerCase())
              );
            });
          if (legOption) {
            this.handleProductSelection(legOption, this.legProducts);
          }
        }

        if (defaultFeatures.orientation && !urlHas("corner")) {
          const orientationRadio = this.container.querySelector(
            `input[type="radio"][name="Corner"][value*="${defaultFeatures.orientation}"]`,
          );
          if (orientationRadio) {
            orientationRadio.checked = true;
            orientationRadio.dispatchEvent(new Event("change"));
          }
        }
      }
    },

    fixFabricPrices: function () {
      const fabricSamplesContainer = document.querySelector(
        ".product-page-fabric-samples",
      );
      if (!fabricSamplesContainer) return;

      const builderConfig =
        fabricSamplesContainer.getAttribute("data-builder-configuration") || "";
      if (!builderConfig) return;

      // Exact option match first: configuration names overlap as substrings
      // ("sectional with bumper" is inside "u sectional with bumper").
      const findConfigVariant = (variants, config) =>
        variants.find((v) => v.option && v.option.trim() === config) ||
        variants.find((v) => v.option && v.option.includes(config));

      const cards = fabricSamplesContainer.querySelectorAll(
        ".fabric-samples-card",
      );
      cards.forEach((card) => {
        const variantScript = card.querySelector("script.variant-prices-json");
        if (variantScript) {
          try {
            const variants = JSON.parse(variantScript.textContent);
            const match = findConfigVariant(variants, builderConfig);
            const selected = match || variants[0];
            if (selected) {
              card.setAttribute("data-product-price", selected.price);
              card.setAttribute("data-variant-id", selected.id);
            }
          } catch (e) {
            console.error("Error parsing variant prices:", e);
          }
        } else if (window.FabricSamplesRenderer) {
          const variantId = parseInt(
            card.dataset.variantId || card.dataset.productId,
            10,
          );
          const product =
            window.FabricSamplesRenderer.getProductByVariantId(variantId);
          if (product && product.variants) {
            const match = findConfigVariant(product.variants, builderConfig);
            const selected = match || product.variants[0];
            if (selected) {
              card.setAttribute("data-product-price", selected.price);
              card.setAttribute("data-variant-id", selected.id);
            }
          }
        }
      });
    },

    setupDecideLater: function () {
      const box = this.container.querySelector(".fabric-samples-decide-later");
      if (!box) return;

      const checkbox = box.querySelector(
        ".fabric-samples-decide-later__checkbox",
      );
      if (!checkbox) return;

      this.decideLaterBox = box;
      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          this.selectDecideLater();
        } else {
          this.deselectDecideLater();
        }
      });
    },

    moveDecideLaterAfterCollection: function () {
      const container = this.container.querySelector(
        ".fabric-samples-decide-later-container",
      );
      if (!container) return;

      const collectionElement = this.container.querySelector(
        "collection-fabric-samples",
      );
      if (!collectionElement) return;

      collectionElement.insertAdjacentElement("afterend", container);
    },

    toggleProductionEstimate: function (isDecideLater) {
      this.container
        .querySelectorAll("[data-production-estimate]")
        .forEach((el) => {
          const defaultText = el.querySelector(
            ".production-estimate-text--default",
          );
          const decideLaterText = el.querySelector(
            ".production-estimate-text--decide-later",
          );
          if (defaultText) defaultText.hidden = isDecideLater;
          if (decideLaterText) decideLaterText.hidden = !isDecideLater;
        });

      // Keep the visible cart/checkout property in step with what is shown.
      document
        .querySelectorAll("input[data-estimated-completion]")
        .forEach((input) => {
          input.value = isDecideLater
            ? input.dataset.decideLaterValue
            : input.dataset.defaultValue;
        });
    },

    selectDecideLater: function () {
      const box = this.decideLaterBox;
      if (!box) return;

      // "Decide Later" and a real fabric swatch are mutually exclusive.
      this.container
        .querySelectorAll(".fabric-samples-card.active")
        .forEach((card) => card.classList.remove("active"));
      box.classList.add("active");

      const selectionContainer = box.closest(".product-selector-box");
      const panelLabel = selectionContainer?.querySelector(".panel-selection");
      if (panelLabel) panelLabel.innerText = box.dataset.productLabel;

      const priceTag = document.querySelector(".pdp-fabric-price-tag");
      if (priceTag) {
        const format =
          window.theme.settings.money_with_currency_format || "${{amount}}";
        priceTag.innerHTML = `+${formatMoney(box.dataset.productPrice, format)}`;
      }

      selectionContainer?.classList.remove("enavi_option_error");

      // "Decide Later" has no swatch details, so hide the View Details button.
      const viewDetails = selectionContainer?.querySelector(
        ".pdp-fabric-view-details",
      );
      if (viewDetails) viewDetails.classList.add("hidden");

      this.toggleProductionEstimate(true);
      this.evaluateTotalPrice();
      this.updateSelectionText();
      this.updateStepCompletionStatus();
    },

    deselectDecideLater: function () {
      const box = this.decideLaterBox;
      if (!box) return;

      box.classList.remove("active");

      const priceTag = document.querySelector(".pdp-fabric-price-tag");
      if (priceTag) priceTag.innerHTML = "";

      const selectionContainer = box.closest(".product-selector-box");
      const panelLabel = selectionContainer?.querySelector(".panel-selection");
      if (panelLabel) panelLabel.innerText = "--";

      this.toggleProductionEstimate(false);
      this.evaluateTotalPrice();
      this.updateSelectionText();
      this.updateStepCompletionStatus();
    },

    clearDecideLater: function () {
      const box =
        this.decideLaterBox ||
        this.container.querySelector(".fabric-samples-decide-later");
      if (!box) return;

      box.classList.remove("active");
      const checkbox = box.querySelector(
        ".fabric-samples-decide-later__checkbox",
      );
      if (checkbox) checkbox.checked = false;
      this.toggleProductionEstimate(false);
    },

    // A saved configuration needs the catalog now to restore its fabric;
    // otherwise it loads when the customer goes for the Fabric step.
    startFabricLoading: function () {
      const savedConfig = window.SofaConfigUrl?.parseConfigFromSearch(window.location.search);
      if (savedConfig?.fabric) this.loadFabrics();
      else this.warmFabricsOnIntent();
    },

    // Fetch (but do not render) the catalog as the customer reaches for the
    // Fabric step, so opening it is not held up by a cold request.
    warmFabricsOnIntent: function () {
      const heading = this.container.querySelector(
        '.product-selector-box[data-selector-type="Fabric"] .box-heading',
      );
      const collectionUrl = this.container.querySelector(".product-page-fabric-samples")
        ?.dataset.fabricCollectionUrl;
      if (!heading || !collectionUrl) return;
      const warm = () => {
        if (this.fabricDocPromise || this.fabricLoadPromise || this.fabricsLoaded) return;
        const request = window.FabricSamplesRenderer.fetchCollection(collectionUrl);
        request.catch(() => {
          if (this.fabricDocPromise === request) this.fabricDocPromise = null;
        });
        this.fabricDocPromise = request;
      };
      ["pointerenter", "touchstart", "focusin"].forEach((type) =>
        heading.addEventListener(type, warm, { once: true, passive: true }));
    },

    loadFabrics: function () {
      if (this.fabricsLoaded) return Promise.resolve(true);
      if (this.fabricLoadPromise) return this.fabricLoadPromise;
      const container = this.container.querySelector(".product-page-fabric-samples");
      const collectionUrl = container?.dataset.fabricCollectionUrl;
      if (!collectionUrl) return Promise.resolve(false);
      const status = document.createElement("div");
      status.className = "fabric-load-status";
      status.setAttribute("role", "status");
      status.textContent = "Loading fabrics…";
      container.replaceChildren(status);
      container.setAttribute("aria-busy", "true");
      // Size an already open step (the "Try again" path) for the reserved height.
      if (this.fabricContainer?.closest(".product-selector-box.active")) {
        this.fabricContainer.style.maxHeight = this.fabricContainer.scrollHeight + "px";
      }
      const fabricDoc = this.fabricDocPromise || window.FabricSamplesRenderer.fetchCollection(collectionUrl);
      this.fabricDocPromise = null;
      this.fabricLoadPromise = fabricDoc
        .then(async (doc) => {
          // A warmed request may already be settled; let the opened step paint
          // before building the cards instead of doing it inside the click.
          if (document.visibilityState === "visible") {
            await new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)));
          }
          const header = doc.querySelector(".fabric-samples-header");
          const body = doc.querySelector(".fabric-samples-body");
          const json = doc.querySelector("#fabric-samples-data");
          if (!header || !body || !json) throw new Error("Fabric collection is unavailable");
          const data = JSON.parse(json.textContent);
          container.replaceChildren(header.cloneNode(true), body.cloneNode(true));
          // Quick filter pills are for the fabric samples page only, not the PDP fabric step.
          container.querySelectorAll(".fabric-samples-quick-filters").forEach((el) => el.remove());
          await window.FabricSamplesRenderer.initFromData(data, collectionUrl);
          this.moveDecideLaterAfterCollection();
          this.fixFabricPrices();
          this.resetEventListeners();
          this.applyDefaultFabric();
          this.fabricsLoaded = true;
          document.dispatchEvent(new CustomEvent("pdp-fabric-samples:loaded"));
          this.setupFabricNameScrollDetection();
          document.addEventListener("pdp-fabric-samples:updated", () => this.fixFabricPrices());
          this.setupFilterClickOutside();
          this.setupMobileScrollbar();
          return true;
        })
        .catch((error) => {
          console.error("Error loading fabric samples:", error);
          status.textContent = "Fabrics could not be loaded. ";
          const retry = document.createElement("button");
          retry.type = "button";
          retry.textContent = "Try again";
          retry.addEventListener("click", () => this.loadFabrics());
          status.appendChild(retry);
          container.replaceChildren(status);
          return false;
        })
        .finally(() => {
          this.fabricLoadPromise = null;
          container.removeAttribute("aria-busy");
          if (this.fabricContainer?.closest(".product-selector-box.active")) {
            this.fabricContainer.style.maxHeight = this.fabricContainer.scrollHeight + "px";
          }
        });
      return this.fabricLoadPromise;
    },

    setupFabricNameScrollDetection: function () {
      const filterValueLists = document.querySelectorAll(
        ".product-page-fabric-samples .fabric-samples-filter-content .fabric-samples-filter-values",
      );
      filterValueLists.forEach(function (list) {
        // Check overflow and toggle has-overflow class
        var checkOverflow = function () {
          list.classList.toggle(
            "has-overflow",
            list.scrollHeight > list.clientHeight,
          );
        };

        // Scroll listener for scrolled-to-bottom detection
        list.addEventListener("scroll", function () {
          var isAtBottom =
            list.scrollHeight - list.scrollTop - list.clientHeight < 10;
          list.classList.toggle("scrolled-to-bottom", isAtBottom);
        });

        // Check overflow when the parent details element opens
        var details = list
          .closest(".fabric-samples-filter-item")
          ?.querySelector(".fabric-samples-filter-details");
        if (details) {
          details.addEventListener("toggle", checkOverflow);
        }
      });
    },

    setupMobileScrollbar: function () {
      if (window.innerWidth > 768) return;

      var container = document.querySelector(
        ".product-page-fabric-samples .fabric-samples-container",
      );
      if (!container) return;

      // Use the parent as the positioning wrapper so the track stays fixed
      var wrapper = container.parentElement;
      wrapper.style.position = "relative";

      // Create scrollbar track and thumb outside the scroll container
      var track = document.createElement("div");
      track.className = "fabric-samples-scroll-track";
      var thumb = document.createElement("div");
      thumb.className = "fabric-samples-scroll-thumb";
      track.appendChild(thumb);
      wrapper.appendChild(track);

      // Auto-hide timer — only hides when scrolled away from top
      var hideTimer = null;

      var showScrollbar = function () {
        track.classList.add("visible");
        clearTimeout(hideTimer);
      };

      var hideScrollbarAfterDelay = function () {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          track.classList.remove("visible");
        }, 3000);
      };

      var updateThumb = function () {
        var scrollRatio = container.clientHeight / container.scrollHeight;
        // Hide if content doesn't overflow
        if (scrollRatio >= 1) {
          track.style.display = "none";
          return;
        }
        track.style.display = "";
        // Match track height and position to the scroll container
        track.style.height = container.clientHeight + "px";
        track.style.top = container.offsetTop + "px";

        var thumbHeight = Math.max(scrollRatio * container.clientHeight, 30);
        var maxScroll = container.scrollHeight - container.clientHeight;
        var scrollPercent = container.scrollTop / maxScroll;
        var maxThumbTop = container.clientHeight - thumbHeight;

        thumb.style.height = thumbHeight + "px";
        thumb.style.top = scrollPercent * maxThumbTop + "px";
      };

      container.addEventListener("scroll", function () {
        updateThumb();
        showScrollbar();

        // At initial position (top) — keep visible, don't auto-hide
        if (container.scrollTop <= 0) {
          clearTimeout(hideTimer);
        } else {
          // Scrolled away from top — start 3s hide timer
          hideScrollbarAfterDelay();
        }
      }, { passive: true });

      updateThumb();
      // Show on initial load so user knows content is scrollable
      showScrollbar();

      // Re-calculate and show when filters change content
      document.addEventListener("pdp-fabric-samples:updated", function () {
        setTimeout(function () {
          container.scrollTop = 0;
          updateThumb();
          showScrollbar();
        }, 100);
      });

      // Show when fabric accordion is opened
      document.addEventListener("fabric-accordion:opened", function () {
        setTimeout(function () {
          updateThumb();
          showScrollbar();
        }, 350); // wait for accordion expand animation
      });
    },

    setupFilterClickOutside: function () {
      document.addEventListener("click", function (e) {
        // Only apply on desktop — don't interfere with mobile filter drawer
        if (window.innerWidth < 981) return;

        // Close any open fabric filter dropdowns if click is outside
        const openFilters = document.querySelectorAll(
          ".product-page-fabric-samples .fabric-samples-filter-details[open], .product-page-fabric-samples .fabric-samples-sort-details[open]",
        );
        openFilters.forEach(function (details) {
          const filterItem =
            details.closest(".fabric-samples-filter-item") ||
            details.closest(".fabric-samples-sort-item");
          if (filterItem && !filterItem.contains(e.target)) {
            details.removeAttribute("open");
          }
        });
      });
    },

    // Bumper Opening and Chaise Width have no option dropdown — the React slider
    // owns them and writes them straight to the ATC form as line-item properties.
    // Reading them back from those inputs also gates them per configuration for
    // free: the slider only writes each one on the configurations that have it.
    sliderDimensionProperty: function (name) {
      const form =
        document.querySelector("#AddToCart")?.closest("form") ||
        document.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[action="/cart/add"]');

      const input = form?.querySelector(`input[name="properties[${name}]"]`);
      const value = input?.value?.trim();

      return value || null;
    },

    // Addon product titles carry a diagram callout letter — "Sectional Width (A)".
    // It means nothing without the diagram in front of you, so drop it from the
    // summary. Display only: the product title still backs the cart property key.
    dimensionLabel: function (fieldName) {
      return (fieldName || "").replace(/\s*\([A-Za-z]\)\s*$/, "").trim();
    },

    buildDimensionGroup: function (items) {
      const group = document.createElement("div");
      group.className = "sofa-builder-dimension-group";

      items.forEach(({ value, label }) => {
        const dimensionItem = document.createElement("div");
        dimensionItem.className = "sofa-builder-dimension-item";
        dimensionItem.innerHTML = `
          <div class="sofa-builder-dimension-value">${value}</div>
          <div class="sofa-builder-dimension-label">${this.dimensionLabel(label)}</div>
        `;

        group.appendChild(dimensionItem);
      });

      return group;
    },

    updateDimensions: function () {
      const sizeDropdowns = Array.from(
        this.container.querySelectorAll(
          ".size-dropdown select, .depth-dropdown select",
        ),
      );
      const dimensionsContainer = document.querySelector(
        ".sofa-builder-dimensions",
      );

      if (!dimensionsContainer) return;

      dimensionsContainer.innerHTML = "";

      const dimensionGroups = {};

      sizeDropdowns.forEach((dropdown) => {
        const addonType =
          dropdown.closest(".option-dropdown").dataset.addonType;
        if (!dimensionGroups[addonType]) {
          dimensionGroups[addonType] = [];
        }
        dimensionGroups[addonType].push(dropdown);
      });

      const bumperOpening = this.sliderDimensionProperty("Bumper Opening");
      const chaiseWidth = this.sliderDimensionProperty("Chaise Width");
      let bumperOpeningPlaced = false;
      let chaiseWidthPlaced = false;

      Object.entries(dimensionGroups).forEach(([groupType, dropdowns]) => {
        const isBumperLength =
          /bumper/i.test(groupType) && /length/i.test(groupType);
        // Double Chaise has Left/Right Length dropdowns but a single shared
        // width, so anchor to whichever chaise length comes first.
        const isChaiseLength =
          /chaise/i.test(groupType) && /length/i.test(groupType);

        if (chaiseWidth && !chaiseWidthPlaced && isChaiseLength) {
          dimensionsContainer.appendChild(
            this.buildDimensionGroup([
              { value: chaiseWidth, label: "Chaise Width" },
            ]),
          );
          chaiseWidthPlaced = true;
        }

        const items = dropdowns.map((dropdown) => {
          const selectedOption = dropdown.options[dropdown.selectedIndex];
          const optionText = selectedOption.value;
          const value =
            // Ottoman dimensions are a combined pair ('40" x 44"'). Taking the
            // first number, as the single-dimension pattern below does, dropped
            // the length and reported a 40x44 ottoman as just 40".
            optionText.match(/\d+\s*["']\s*[xX×]\s*\d+\s*["']/)?.[0] ||
            // Sofa options carry one dimension plus trimmings ('86" - Popular').
            optionText.match(/(\d+["'])/)?.[0] ||
            optionText;

          return { value, label: dropdown.dataset.fieldName };
        });

        dimensionsContainer.appendChild(this.buildDimensionGroup(items));

        if (bumperOpening && !bumperOpeningPlaced && isBumperLength) {
          dimensionsContainer.appendChild(
            this.buildDimensionGroup([
              { value: bumperOpening, label: "Bumper Opening" },
            ]),
          );
          bumperOpeningPlaced = true;
        }
      });

      // No anchor dropdown found — show the value rather than dropping it.
      if (chaiseWidth && !chaiseWidthPlaced) {
        dimensionsContainer.appendChild(
          this.buildDimensionGroup([
            { value: chaiseWidth, label: "Chaise Width" },
          ]),
        );
      }

      if (bumperOpening && !bumperOpeningPlaced) {
        dimensionsContainer.appendChild(
          this.buildDimensionGroup([
            { value: bumperOpening, label: "Bumper Opening" },
          ]),
        );
      }
    },

    updateSelectionText: function () {
      const selectionTextContainer = document.querySelector(
        ".sofa-builder-selection-text",
      );
      if (!selectionTextContainer) return;

      const styleSelection = document.querySelector(
        '[data-selector-type="Style"] .ottoman-style_option.active',
      );
      if (styleSelection) {
        const styleText = document.querySelector(
          ".sofa-builder-selection-style",
        );
        if (styleText) {
          styleText.textContent = styleSelection.dataset.styleName;
        }
      }

      const fabricSelection = document.querySelector(
        '[data-selector-type="Fabric"] .enavi_addon.active',
      );
      if (fabricSelection) {
        const fabricText = document.querySelector(
          ".sofa-builder-selection-fabric",
        );
        if (fabricText) {
          fabricText.textContent = fabricSelection.dataset.productLabel;
        }
      }

      const orientationSelection = document.querySelector(
        '[data-selector-type="Size"] .radio-choice input[name="Corner"]:checked',
      );
      if (orientationSelection) {
        const orientationText = document.querySelector(
          ".sofa-builder-selection-orientation",
        );
        if (orientationText) {
          orientationText.textContent = orientationSelection.value;
        }
      }

      const armlessSelection = document.querySelector(
        '[data-selector-type="Size"] .radio-choice input[name="Armless Side"]:checked',
      );
      if (armlessSelection) {
        const armlessText = document.querySelector(
          ".sofa-builder-selection-armless",
        );
        if (armlessText) {
          armlessText.textContent = armlessSelection.value;
        }
      }

      // Skip the cushion row only when the React slider owns it — it writes the
      // computed counts itself. Keyed on the marker rather than visibility: the
      // ottoman hides this box because there is only "Standard" to pick, and
      // testing display:none left the summary stuck on "--".
      const cushionSelector = document.querySelector(
        '[data-selector-type="Cushions"]',
      );
      const isCushionOwnedBySlider =
        cushionSelector &&
        (cushionSelector.hasAttribute("data-cushions-owned-by-slider") ||
          cushionSelector.id === "product-cushions-box-hide");

      if (!isCushionOwnedBySlider) {
        const cushionSelection = document.querySelector(
          '[data-selector-type="Cushions"] .enavi_addon.active',
        );
        if (cushionSelection) {
          const cushionText = document.querySelector(
            ".sofa-builder-selection-cushions",
          );
          if (cushionText) {
            cushionText.textContent = cushionSelection.dataset.productLabel;
          }
        }
      }

      const firmnessSelection = document.querySelector(
        '[data-selector-type="Firmness"] .enavi_addon.active',
      );
      if (firmnessSelection) {
        const firmnessText = document.querySelector(
          ".sofa-builder-selection-firmness",
        );
        if (firmnessText) {
          const price = parseInt(firmnessSelection.dataset.productPrice, 10);
          let label = firmnessSelection.dataset.productLabel;
          if (price && price > 0) {
            let format =
              window.theme?.settings?.money_with_currency_format ||
              "${{amount}}";
            label += ` +(${formatMoney(price, format)})`;
          }
          firmnessText.textContent = label;
        }
      }

      const legSelection = document.querySelector(
        '[data-selector-type="Legs"] .enavi_addon.active',
      );
      if (legSelection) {
        const legText = document.querySelector(".sofa-builder-selection-legs");
        if (legText) {
          legText.textContent = legSelection.dataset.productLabel;
        }
      }
    },

    updateStepCompletionStatus: function (targetStep = null) {
      const stepSelectors = this.selectAll(selectors.productSelector);

      const stepsToCheck = targetStep ? [targetStep] : stepSelectors;

      stepsToCheck.forEach((step) => {
        const stepNumber = step.querySelector(".step_number");
        const stepDetails = step.querySelector(".step_details");
        const boxContent = step.querySelector(".box-content");
        const selectorType = step.dataset.selectorType;
        let isComplete = false;

        switch (selectorType) {
          case "Style":
            isComplete = !!step.querySelector(".ottoman-style_option.active");
            break;

          case "Fabric":
            isComplete = !!step.querySelector(".enavi_addon.active");
            break;

          case "Depth":
            const depthOptions = step.querySelectorAll(".selector-option");
            isComplete = Array.from(depthOptions).every((option) => {
              const select = option.querySelector("select");
              return select && select.selectedIndex > 0;
            });
            break;

          case "Size":
            const sizeOptions = step.querySelectorAll(
              ".selector-option:not(.radio-option)",
            );
            const radioOption = step.querySelector(".radio-option");

            const dropdownsComplete = Array.from(sizeOptions).every(
              (option) => {
                const select = option.querySelector("select");
                return select && select.selectedIndex > 0;
              },
            );

            const radioComplete =
              !radioOption ||
              !!radioOption.querySelector('input[type="radio"]:checked');

            isComplete = dropdownsComplete && radioComplete;
            break;

          case "Cushions":
            isComplete = !!step.querySelector(".enavi_addon.active");
            break;

          case "Firmness":
            isComplete = !!step.querySelector(".enavi_addon.active");
            break;

          case "Legs":
            isComplete = !!step.querySelector(".enavi_addon.active");
            break;
        }

        if (stepDetails) {
          if (isComplete) {
            stepDetails.classList.add("step-complete");
          } else {
            stepDetails.classList.remove("step-complete");
          }
        }
      });

      // Runs after every selection, so it is the natural place to drop the
      // error state from a step the customer has just answered — otherwise the
      // red outline sat there until the next Add to Cart.
      this.clearSatisfiedAddonErrors();
    },
  });

  return EnaviSofaBuilder;
})();

// One builder per page. Kept on `theme` so debugging sessions and tests can reach
// the live instance instead of constructing a second one, which would double-bind
// every click handler.
theme.sofaBuilder = new theme.EnaviSofaBuilder(
  document.querySelector(".product-information"),
);
class CylindoViewerCustomizer {
  constructor() {
    this.mobileBreakpoint = window.matchMedia("(max-width: 768px)");
    this.cylindoViewer = document.querySelector("cylindo-viewer");
    this.cylindoThumbnailBar = document.querySelector("cylindo-thumbnail-bar");

    if (this.cylindoViewer && this.cylindoThumbnailBar) {
      this.cylindoViewerRoot = this.cylindoViewer.shadowRoot;
      this.cylindoThumbnailBarRoot = this.cylindoThumbnailBar.shadowRoot;
      this.layoutWrapper =
        this.cylindoViewerRoot?.querySelector(".layoutWrapper");

      this.init();
    }
  }

  init() {
    this.styleButtons();
    this.styleButtonGroup();

    this.handleResponsiveChanges(this.mobileBreakpoint);

    this.mobileBreakpoint.addEventListener("change", (e) =>
      this.handleResponsiveChanges(e),
    );

    document
      .querySelector(".alternate-style details")
      ?.addEventListener("click", (e) => {
        e.target?.classList.toggle("clamp-text");
      });
  }

  styleButtons() {
    const buttons = this.cylindoViewerRoot?.querySelectorAll("button.fab svg");
    if (buttons) {
      buttons.forEach((button) => {
        button.style.stroke = "#ffffff";
      });
    }
  }

  styleButtonGroup() {
    const buttonGroups =
      this.cylindoViewerRoot?.querySelectorAll(".button-group");
    if (buttonGroups) {
      buttonGroups.forEach((buttonGroup) => {
        buttonGroup.style.right = "1.5em";
      });
    }
  }

  handleResponsiveChanges(e) {
    this.adjustLayoutWrapperPadding(e);
  }

  adjustLayoutWrapperPadding(e) {
    if (this.layoutWrapper) {
      this.layoutWrapper.style.padding = e.matches ? "0" : "0 16px";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CylindoViewerCustomizer();
});

// The customizer restyles the viewer's shadow DOM, so it has to run again
// whenever the ottoman style step replaces the <cylindo-viewer> element.
window.refreshCylindoViewerCustomizer = function () {
  new CylindoViewerCustomizer();
};
